import React, { useCallback, useState } from "react";
import { CSVLink } from "react-csv";
import classNames from "classnames";
import { format, differenceInDays } from "date-fns";
import { Auth, API, Storage } from "aws-amplify";
import {
  getCurrentLocalDateTime,
  months,
  pad,
} from "../../utils/getLocalDateTime";
import ReactExport from "react-data-export";
import ContainerContent from "../Container/ContainerContent";
import _ from "lodash";
import numeral from "numeral";
import AgingExport from "./agingExport";
import DebtorExport from "components/Report/debtor";
import DebtorPayment from "components/Report/debtorPayment";
import ReportLoanRequest from "components/Report/reportLoanRequest";
import ReportRelationship from "components/Report/relationReport";
import ReportARClearRemain from "components/Report/reportArClearRemain";
import DebtorErrorExport from "components/Report/debtorError";
import ReportGood from "./reportGood";
import ReportBad from "./reportBad";
import { calcuratorInterestTwo } from "utils/reinstallments";
import { reinstallments } from "utils/reinstallments";
import axios from "axios";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const BoxChooseDateCelestialCode = ({
  selectToday,
  setSelectToday,
  loadingExportArClearCelestial,
  loadingExportInterfaceCreateCelestial,
  loadingExportAccruedCelestial,
  loadingAccruedError,
  onClickExportInterfaceCreateCelestial,
  onClickExportAccruedInterestCelestial,
  onClickExportAccruedInterestCelestialError,
  onClickExportARClearCelestial,
  countAccrued,
  countAccruedError,
  loadingOne,
  loadingTwo,
  loadingThree,
  sess,
  setSess,
  loanFeb,
  setLoanFeb,
}) => {
  const [loadingSES, setLoadingSES] = useState(false);
  const [countSES, setCountSES] = useState(0);
  const [loadingLoanFeb, setLoadingLoanFeb] = useState(false);
  const [countLoanFeb, setCountLoanFeb] = useState(0);

  const getLastItem = (lastItem) => {
    let lastItemStr = "";
    if (lastItem) {
      const lastItemKeys = Object.keys(lastItem);
      lastItemKeys.forEach((key) => {
        lastItemStr += `${key}=${lastItem[key]}&`;
      });
    }
    return lastItemStr;
  };

  const onClickExportSES = async () => {
    try {
      const splitMonth = selectToday.split("-");
      const year = splitMonth[0];
      const month = splitMonth[1];
      const day = splitMonth[2];
      const exportExcel = document.getElementById("export-excel-ses");

      let data = { Items: [] };
      let lastItem = null;
      let datas = {};
      let count = 0;
      do {
        datas = await API.get("MoneyHubAdmin", "/loan/reportSES", {
          queryStringParameters: {
            Limit: 1,
            date: `${year}-${month}-${day}`,
            ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = datas?.lastItem;
        count += datas?.count;
        data.Items = [...data.Items, ...datas.notifications];
        setCountSES(count);
      } while (lastItem);

      // const filterItems = data.Items.reduce((prev, curr) => {
      //   const foundMessageId = prev.findIndex(
      //     (prevItem) =>
      //       prevItem.SESMessageId === curr.SESMessageId &&
      //       String(curr.SESMessageType).toUpperCase() !== "Send"
      //   );
      //   if (foundMessageId > -1) {
      //     prev[foundMessageId] = {
      //       ...prev[foundMessageId],
      //       SnsReceiveDate: curr.SnsPublishTime,
      //     };
      //     return prev;
      //   }
      //   return [...prev, curr];
      // }, []);

      setSess(
        data?.Items.sort((a, b) => {
          return new Date(b?.SnsPublishTime) - new Date(a?.SnsPublishTime);
        })
      );
      exportExcel.click();
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingSES(false);
    }
  };

  const onClickLoanFeb = async () => {
    try {
      setLoadingLoanFeb(true);

      const splitMonth = selectToday.split("-");
      const year = splitMonth[0];
      const month = splitMonth[1];
      const day = splitMonth[2];
      const exportExcel = document.getElementById("export-excel-loan-feb");

      let data = { Items: [] };
      let lastItem = null;
      let datas = {};
      let count = 0;
      do {
        const { data: dataApi } = await axios.get(
          "https://3jlyrslj4e3mpc2c7ttmp4n63i0raosw.lambda-url.ap-southeast-1.on.aws/",
          {
            params: {
              date: `${year}-${month}-${day}`,
              ExclusiveStartKey: getLastItem(lastItem),
            },
          }
        );
        datas = dataApi;
        lastItem = datas?.lastItem;
        count += datas?.Items?.length;
        data.Items = [...data.Items, ...datas.Items];
        setCountLoanFeb(count);
      } while (lastItem);

      let dataReport = [];
      for (const item of data.Items) {
        const createdReport = {
          loan_kbank_id: item.loan_kbank_id,
          requestTimeFullDate: item?.requestTimeFullDate,
          currentActualInterest:
            item?.installments?.[item?.latest_update_installment_index]
              ?.oldActualInterest,
          newActualInterest:
            item?.installments?.[item?.latest_update_installment_index]
              ?.actualInterest,
        };
        dataReport.push(createdReport);
      }
      setLoanFeb(dataReport);
      exportExcel.click();
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingLoanFeb(false);
    }
  };

  return (
    <div className="p-4 border border-gray-200 shadow-xl my-0">
      <div className="font-bold text-xl">Sandbox</div>
      <div className="">
        <div>เลือกวันที่</div>
        <input
          type="date"
          value={selectToday}
          onChange={(e) => setSelectToday(e.target.value)}
          className="p-2 border border-gray-200 mt-2 w-full rounded-lg"
        />
        <button
          disabled={loadingLoanFeb}
          className={classNames(
            "p-4 w-full text-white mt-2 flex flex-row rounded-lg items-center",
            {
              "bg-green-500": !loadingLoanFeb,
              "bg-gray-400": loadingLoanFeb,
            }
          )}
          onClick={onClickLoanFeb}
        >
          Loan Feb ({countLoanFeb})
        </button>
        <button
          disabled={loadingExportInterfaceCreateCelestial}
          className={classNames(
            "p-4 w-full  text-white mt-2 flex flex-row rounded-lg items-center",
            {
              "bg-green-500": !loadingExportInterfaceCreateCelestial,
              "bg-gray-400": loadingExportInterfaceCreateCelestial,
            }
          )}
          onClick={onClickExportInterfaceCreateCelestial("REAL")}
        >
          {loadingExportInterfaceCreateCelestial && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
            />
          </svg>
          Interface Create
        </button>
        <button
          disabled={loadingExportAccruedCelestial}
          className={classNames(
            "p-4 w-full text-white mt-2 flex flex-row rounded-lg items-center",
            {
              "bg-green-500": !loadingExportAccruedCelestial,
              "bg-gray-400": loadingExportAccruedCelestial,
            }
          )}
          onClick={onClickExportAccruedInterestCelestial}
        >
          {loadingExportAccruedCelestial && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
            />
          </svg>
          ({countAccrued > 0 && <div className="">{countAccrued}</div>})&nbsp;
          Accrued Interest
        </button>
        
        {/* <button
          disabled={loadingAccruedError}
          className={classNames(
            "p-4 w-full text-white mt-2 flex flex-row rounded-lg items-center",
            {
              "bg-green-500": !loadingAccruedError,
              "bg-gray-400": loadingAccruedError,
            }
          )}
          onClick={onClickExportAccruedInterestCelestialError}
        >
          {loadingAccruedError && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
            />
          </svg>
          (
          {countAccruedError > 0 && <div className="">{countAccruedError}</div>}
          )&nbsp; Accrued Interest Error
        </button> */}

        <button
          disabled={loadingExportArClearCelestial}
          className={classNames(
            "p-4  text-white mt-2 flex flex-row rounded-lg items-center w-full",
            {
              "bg-green-500": !loadingExportArClearCelestial,
              "bg-gray-400": loadingExportArClearCelestial,
            }
          )}
          onClick={onClickExportARClearCelestial}
        >
          {loadingExportArClearCelestial && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
            />
          </svg>
          AR Clear
        </button>
        <AgingExport selectToday={selectToday} />
        <DebtorExport selectToday={selectToday} />
        <DebtorPayment selectToday={selectToday} />
        <ReportLoanRequest selectToday={selectToday} />
        <DebtorErrorExport selectToday={selectToday} />
        <button
          disabled={loadingOne}
          className={classNames(
            "p-4 w-full  text-white mt-2 flex flex-row rounded-lg items-center",
            {
              "bg-green-500": !loadingOne,
              "bg-gray-400": loadingOne,
            }
          )}
          onClick={onClickExportInterfaceCreateCelestial("ONE")}
        >
          {loadingOne && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
            />
          </svg>
          <div className="flex flex-col items-start">
            <div>Interface Create One 8.05</div>
            <div>(T = 0.00 - 8.04) (T + 1 = 16:31 - 23:59)</div>
            <div>(T + 1 = ธนาคารอื่นๆ (BBL, KBANK, SCB, KTB))</div>
          </div>
        </button>
        <button
          disabled={loadingTwo}
          className={classNames(
            "p-4 w-full  text-white mt-2 flex flex-row rounded-lg items-center",
            {
              "bg-green-500": !loadingTwo,
              "bg-gray-400": loadingTwo,
            }
          )}
          onClick={onClickExportInterfaceCreateCelestial("TWO")}
        >
          {loadingTwo && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
            />
          </svg>
          <div className="flex flex-col items-start">
            <div>Interface Create Two 13:35</div>
            <div>(T = 8:05 - 13:34)</div>
          </div>
        </button>
        <button
          disabled={loadingThree}
          className={classNames(
            "p-4 w-full  text-white mt-2 flex flex-row rounded-lg items-center",
            {
              "bg-green-500": !loadingThree,
              "bg-gray-400": loadingThree,
            }
          )}
          onClick={onClickExportInterfaceCreateCelestial("THREE")}
        >
          {loadingThree && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
            />
          </svg>
          <div className="flex flex-col items-start">
            <div>Interface Create Three 16:36</div>
            <div>(T = 13:35 - 16:35)</div>
          </div>
        </button>
        <button
          disabled={loadingSES}
          className={classNames(
            "p-4 w-full  text-white mt-2 flex flex-row rounded-lg items-center",
            {
              "bg-green-500": !loadingSES,
              "bg-gray-400": loadingSES,
            }
          )}
          onClick={onClickExportSES}
        >
          {loadingSES && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
            />
          </svg>
          <div className="flex flex-col items-start">
            <div>{countSES} Report SES</div>
          </div>
        </button>
      </div>
    </div>
  );
};

function ReportMain() {
  const dataCsv = ``;

  const today = new Date();

  const [loanFeb, setLoanFeb] = useState([]);
  const [countInterestInCome, setInterestInCome] = useState(0);
  const [countAging, setCountAging] = useState(0);
  const [countContract, setCountContract] = useState(0);
  const [countContract2, setCountContract2] = useState(0);
  const [countPayment, setCountPayment] = useState(0);
  const [countAcc, setCountAcc] = useState(0);
  const [loadingExportAging, setLoadingExportAging] = useState(false);
  const [loadingExportContract, setLoadingExportContract] = useState(false);
  const [loadingExportContract2, setLoadingExportContract2] = useState(false);
  const [loadingExportAnalyze, setLoadingExportAnalyze] = useState(false);
  const [loadingExportForm, setLoadingExportForm] = useState(false);
  const [loadingExportAccrued, setLoadingExportAccrued] = useState(false);
  const [loadingExportPayment, setLoadingExportPayment] = useState(false);
  const [loadingExportInterestIncome, setLoadingExportInterestIncome] =
    useState(false);
  const [loadingExportInterfaceCreate, setLoadingExportInterfaceCreate] =
    useState(false);
  const [
    loadingExportInterfaceCreateCelestial,
    setLoadingExportInterfaceCreateCelestial,
  ] = useState(false);
  const [loadingOne, setLoadingOne] = useState(false);
  const [loadingTwo, setLoadingTwo] = useState(false);
  const [loadingThree, setLoadingThree] = useState(false);
  const [loadingExportAccruedCelestial, setLoadingExportAccruedCelestial] =
    useState(false);
  const [loadingExportArClearCelestial, setLoadingExportArClearCelestial] =
    useState(false);

  const [allContract, setAllContract] = useState([]);
  const [allContract2, setAllContract2] = useState([]);
  const [lateData, setLateData] = useState([]);
  const [dataPrinciple, setPrinciple] = useState([]);
  const [dataInterest, setInterest] = useState([]);
  const [dataForm, setDataForm] = useState([]);
  const [dataAcc, setDataAcc] = useState([]);
  const [countAccrued, setCountAccrued] = useState(0);
  const [countAccruedError, setCountAccruedError] = useState(0);
  const [loadingAccruedError, setLoadingAccruedError] = useState(false);
  const [dataPayment, setDataPayment] = useState([]);
  const [dataInterestIncome, setDataInterestIncome] = useState([]);
  const [dataInterface, setDataInterface] = useState([]);

  const [dateInterest, setDateInterest] = useState(format(today, "yyyy-MM-dd"));

  const [selectToday, setSelectToday] = useState(
    `${getCurrentLocalDateTime().fullDate}`
  );
  const [currentMonth, setCurrentMonth] = useState(
    `${today.getFullYear()}-${today.getMonth() + 1}`
  );
  const [min, setMin] = useState(
    `${today.getFullYear()}-${pad(today.getMonth() + 1)}-01`
  );
  const [max, setMax] = useState(format(today, "yyyy-MM-dd"));
  const [ctoday, setCToday] = useState(format(today, "yyyy-MM-dd"));
  const [ref, setRef] = useState("");
  const [sess, setSess] = useState([]);

  const QUERY_DEFAULT = {
    Limit: 2000,
    countData: 1,
    package: "All",
    min_created: min,
    max_created: max,
  };

  const QUERY_ALL = {
    status: "All",
    ...QUERY_DEFAULT,
  };

  const QUERY_ACTIVE = {
    ...QUERY_DEFAULT,
    status: "ACTIVE",
  };

  const QUERY_FAIL = {
    ...QUERY_DEFAULT,
    status: "FAIL",
  };

  const QUERY_LATE = {
    ...QUERY_DEFAULT,
    status: "LATE",
  };

  const getLastItem = (lastItem) => {
    let lastItemStr = "";
    if (lastItem) {
      const lastItemKeys = Object.keys(lastItem);
      lastItemKeys.forEach((key) => {
        lastItemStr += `${key}=${lastItem[key]}&`;
      });
    }
    return lastItemStr;
  };

  const calculatorDue = (
    rawData = [],
    options = { keyCal: "actualPrinciple" }
  ) => {
    const data = rawData;

    let dataExcel = data.map((loan, i) => {
      let dataLoan = loan;
      let currentInstallment = null;
      let checkInstallment = false;
      let pastInstallments = [];
      let interestNotDue = 0;
      let principleNotDue = 0;
      let checkBreak = false;

      const days = {
        notDue: 0,
        30: 0,
        "31_90": 0,
        "91_180": 0,
        "181_365": 0,
        365: 0,
        total: 0,
      };

      let calActualPrinciple = 0;
      let calActualInterest = 0;

      for (let index = 0; index < dataLoan.installments.length; index++) {
        const installment = dataLoan.installments[index];

        const today = getCurrentLocalDateTime(
          ctoday ? new Date(ctoday) : new Date()
        );
        let checkCurrent = today.fullDate <= installment.date;

        if (checkCurrent) {
          currentInstallment = installment;
          checkInstallment = true;
          break;
        }
        pastInstallments.push(installment);
      }

      if (!checkInstallment) {
        currentInstallment = pastInstallments[pastInstallments.length - 1];
      }

      loan.installments.forEach((installment) => {
        principleNotDue += installment.actualPrinciple;
        interestNotDue += installment.actualInterest;
        // if (!installment.disabledPeriod && !checkBreak) {
        //   interestNotDue += installment.actualInterest;
        //   principleNotDue += installment.actualPrinciple;
        //   // principleNotDue = loan.capitalRemain - installment.actualPrinciple;
        //   // console.log("1", principleNotDue);
        //   // if (installment.actualPrinciple > installment.planPrinciple) {
        //   //   principleNotDue += installment.planPrinciple;
        //   //   console.log("2", principleNotDue);
        //   // }
        //   checkBreak = true;
        // }
      });

      let tempActualPrinciple = currentInstallment.actualPrinciple;
      const tempBwt =
        currentInstallment.actualPrinciple - currentInstallment.planPrinciple;
      tempActualPrinciple = tempBwt;
      if (principleNotDue > currentInstallment.planPrinciple) {
        // const tempBwt =
        //   currentInstallment.actualPrinciple - currentInstallment.planPrinciple;
        tempActualPrinciple = tempBwt;
        if (tempBwt > 0) {
          principleNotDue -= tempBwt;
        }
      }

      if (!checkInstallment) {
        interestNotDue = 0;
        principleNotDue = 0;
      }

      if (pastInstallments.length > 0) {
        if (options.keyCal === "actualPrinciple") {
          calActualPrinciple = tempActualPrinciple;
        } else {
          calActualInterest = currentInstallment.interestMore;
        }
      }

      // console.log("tempActualPrinciple", tempActualPrinciple);

      if (options.keyCal === "actualPrinciple") {
        days.notDue = principleNotDue;
      } else {
        days.notDue = interestNotDue;
      }

      // console.log("BREAK", checkBreak);
      // console.log("PAST", pastInstallments);
      // console.log("i", i);
      // console.log("principleNotDue", principleNotDue);
      // console.log("interestNotDue", interestNotDue);
      // console.log("currentInstallment", currentInstallment);
      // console.log("FIRST", calActualPrinciple);

      let checkPlusSelf = false;
      let tempPrinciple = 0;
      let prevPrinciple = 0;
      let checkPrev = false;
      let checkPrevPrin = false;

      for (let index = pastInstallments.length - 1; index >= 0; index--) {
        if (options.keyCal === "actualPrinciple") {
          // console.log("CAL", calActualPrinciple);
          // console.log("INDEX", index);
          // console.log("pa", pastInstallments[index].planPrinciple);

          // if (tempPrinciple > 0) {
          //   calActualPrinciple -= tempPrinciple;
          //   tempPrinciple = 0;
          // } else {
          // if(!checkPrevPrin) {
          //   calActualPrinciple -= currentInstallment.planPrinciple;
          //   checkPrevPrin = true
          // } else {
          calActualPrinciple -= pastInstallments[index].planPrinciple;
          // }
          // calActualPrinciple -= pastInstallments[index].planPrinciple;
          // }

          // if (!checkInstallment && !checkPlusSelf) {
          //   checkPlusSelf = true;
          //   if (
          //     currentInstallment.actualPrinciple >
          //     currentInstallment.planPrinciple
          //   ) {
          //     calActualPrinciple += currentInstallment.planPrinciple;
          //     tempPrinciple = currentInstallment.planPrinciple;
          //     console.log("IN 1", calActualPrinciple);
          //   } else {
          //     calActualPrinciple += currentInstallment.actualPrinciple;
          //     console.log("IN 2", calActualPrinciple);
          //   }
          // }

          if (!checkInstallment && !checkPlusSelf) {
            checkPlusSelf = true;
            if (tempActualPrinciple > 0) {
              calActualPrinciple += currentInstallment.planPrinciple;
            } else {
              calActualPrinciple += currentInstallment.actualPrinciple;
            }
          }

          if (calActualPrinciple >= 0) {
            pastInstallments[index].actualPrinciple =
              pastInstallments[index].planPrinciple;
            // console.log("1", pastInstallments[index].actualPrinciple);
          } else {
            // if (
            //   prevPrinciple < pastInstallments[index].planPrinciple &&
            //   checkPrev
            // ) {
            //   if(calActualPrinciple > 0)
            //   pastInstallments[index].actualPrinciple = 0;
            // } else {
            pastInstallments[index].actualPrinciple = calActualPrinciple;
            prevPrinciple = calActualPrinciple;
            if (calActualPrinciple < 0) {
              // console.log("3 cal", calActualPrinciple);
              let calPrinciple =
                calActualPrinciple + pastInstallments[index].planPrinciple;
              pastInstallments[index].actualPrinciple = calPrinciple;
              // console.log("3", pastInstallments[index].actualPrinciple);
              checkPrev = true;
              if (pastInstallments[index].actualPrinciple < 0) {
                pastInstallments[index].actualPrinciple = 0;
                // console.log("4", pastInstallments[index].actualPrinciple);
              }
            }
            // }
          }
        } else {
          calActualInterest -= pastInstallments[index].planInterest;

          if (!checkInstallment && !checkPlusSelf) {
            checkPlusSelf = true;
            if (pastInstallments[index].interestMore > 0) {
              calActualInterest += currentInstallment.planInterest;
            } else {
              calActualInterest += currentInstallment.actualInterest;
            }
          }

          // console.log("CAL", calActualInterest);
          if (calActualInterest >= 0) {
            pastInstallments[index].actualInterest =
              pastInstallments[index].planInterest;
            // console.log("2", pastInstallments[index].actualInterest);
          } else {
            pastInstallments[index].actualInterest = calActualInterest;
            if (calActualInterest < 0) {
              pastInstallments[index].actualInterest =
                calActualInterest + pastInstallments[index].planInterest;
              // console.log("3", pastInstallments[index].actualInterest);
              if (pastInstallments[index].actualInterest < 0) {
                pastInstallments[index].actualInterest = 0;
                // console.log("4", pastInstallments[index].actualInterest);
              }
            }
          }
          // console.log("**********************************");
        }
      }

      // console.log("-------------------------------------");

      for (let index = 0; index < pastInstallments.length; index++) {
        const pastInstallment = pastInstallments[index];
        const pastDays = differenceInDays(
          new Date(ctoday),
          new Date(pastInstallment.date)
        );

        // console.log("PAST", pastDays);

        if (pastDays >= 0 && pastDays <= 30) {
          days["30"] += pastInstallment[options.keyCal];
          // days.total += days["30"];
        } else if (pastDays <= 90) {
          days["31_90"] += pastInstallment[options.keyCal];
          // days.total += days["31_90"];
        } else if (pastDays <= 180) {
          days["91_180"] += pastInstallment[options.keyCal];
          // days.total += days["91_180"];
        } else if (pastDays <= 365) {
          days["181_365"] += pastInstallment[options.keyCal];
          // days.total += days["181_365"];
        } else {
          days["365"] += pastInstallment[options.keyCal];
          // days.total += days["365"];
        }
      }

      const daysList = ["30", "31_90", "91_180", "181_365", "365"];

      days.total = daysList.reduce((prev, key) => {
        return prev + days[key];
      }, 0);

      // if (options.keyCal === "actualPrinciple") {
      // days.notDue = days.notDue - days.total;
      // }

      // console.log(
      //   "---------------------------------------------------------------"
      // );

      return {
        customer: `${loan.loan_kbank_id} ${loan.fullname}`,
        loan_status: loan.loan_status,
        ...days,
        total: days.total + days.notDue,
      };
    });

    return dataExcel;
  };

  const onClickExportInterfaceCreate = async () => {
    try {
      setLoadingExportInterfaceCreate(true);
      const today = getCurrentLocalDateTime(new Date(selectToday));
      const exportExcel = document.getElementById(
        "export-excel-interface-create"
      );
      const data = await API.get(
        "MoneyHubAdmin",
        "/loanRequest/reportInterfaceCreate",
        {
          queryStringParameters: {
            valueDate: `${today.year}${pad(today.month)}${pad(today.date)}`,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      setDataInterface([...data?.body.Items]);
      exportExcel.click();
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingExportInterfaceCreate(false);
    }
  };

  const onClickExportInterfaceCreateCelestial =
    (typeCreate = "REAL") =>
    async () => {
      try {
        const today = getCurrentLocalDateTime(new Date(selectToday));
        const exportExcel = document.getElementById(
          "export-excel-interface-create-celestial"
        );

        let pathName = "/loanRequest/reportInterfaceCreate";
        if (typeCreate === "ONE") {
          pathName = "/reportCreateOne";
          setLoadingOne(true);
        } else if (typeCreate === "TWO") {
          pathName = "/reportCreateSecond";
          setLoadingTwo(true);
        } else if (typeCreate === "THREE") {
          pathName = "/reportCreateThird";
          setLoadingThree(true);
        } else {
          setLoadingExportInterfaceCreateCelestial(true);
        }

        const data = await API.get("MoneyHubAdmin", pathName, {
          queryStringParameters: {
            valueDate: `${today.year}${pad(today.month)}${pad(today.date)}`,
            date: `${today.year}-${pad(today.month)}-${pad(today.date)}`,
            sendEmail: false,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });

        console.log("data", data);

        setDataInterface([...(data?.body?.Items || data?.Items)]);
        exportExcel.click();
      } catch (error) {
        console.log("ERROR", error);
      } finally {
        setLoadingExportInterfaceCreateCelestial(false);
        setLoadingOne(false);
        setLoadingTwo(false);
        setLoadingThree(false);
      }
    };

  const onClickExportAccruedInterestCelestial = async () => {
    try {
      setLoadingExportAccruedCelestial(true);
      const exportExcel = document.getElementById(
        "export-excel-accruedInterest-celestial"
      );

      // let { data: formData } = await axios.get(
      //   "http://localhost:1337/loan/accruedInterest",
      //   {
      //     params: {
      //       selectToday,
      //     },
      //     headers: {
      //       Authorization: `Bearer ${(await Auth.currentSession())
      //         .getIdToken()
      //         .getJwtToken()}`,
      //     },
      //   }
      // );

      let lastItem = null;
      let datas = {};
      let count = 0;
      let data = { body: { Items: [] } };

      do {
        datas = await API.get("MoneyHubAdmin", "/loan/accruedInterest", {
          queryStringParameters: {
            selectToday,
            ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = datas?.body?.lastItem;
        count += datas?.body?.count;
        data.body.Items = [...data.body.Items, ...datas.body.Items];
        setCountAccrued(count);
      } while (lastItem);

      const parseData = data?.body?.Items || [];
      setDataAcc([...parseData]);
      exportExcel.click();
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingExportAccruedCelestial(false);
    }
  };

  const onClickExportAccruedInterestCelestialError = async () => {
    try {
      setLoadingAccruedError(true);
      const exportExcel = document.getElementById(
        "export-excel-accruedInterest-celestial"
      );

      // let { data: formData } = await axios.get(
      //   "http://localhost:1337/loan/accruedInterest",
      //   {
      //     params: {
      //       selectToday,
      //     },
      //     headers: {
      //       Authorization: `Bearer ${(await Auth.currentSession())
      //         .getIdToken()
      //         .getJwtToken()}`,
      //     },
      //   }
      // );

      let lastItem = null;
      let datas = {};
      let count = 0;
      let data = { body: { Items: [] } };

      do {
        datas = await API.get("MoneyHubAdmin", "/loan/accruedInterestError", {
          queryStringParameters: {
            selectToday,
            ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = datas?.body?.lastItem;
        count += datas?.body?.count;
        data.body.Items = [...data.body.Items, ...datas.body.Items];
        setCountAccruedError(count);
      } while (lastItem);

      const data2 = await API.get(
        "MoneyHubAdmin",
        "/loan/accruedInterestError2",
        {
          queryStringParameters: {
            selectToday,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      const items2 = data2?.body?.Items || [];

      const parseData = [...data?.body?.Items, ...items2];
      setDataAcc([...parseData]);
      exportExcel.click();
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingAccruedError(false);
    }
  };

  const onClickExportARClearCelestial = async () => {
    try {
      setLoadingExportArClearCelestial(true);
      const exportExcel = document.getElementById(
        "export-excel-arclear-celestial"
      );
      let formData = await API.get("MoneyHubAdmin", "/loan/arClear", {
        queryStringParameters: {
          selectToday,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });

      const parseData = formData.body?.Items || [];

      setDataPayment([...parseData]);
      exportExcel.click();
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingExportArClearCelestial(false);
    }
  };

  const onClickExportPayment = async () => {
    try {
      setLoadingExportPayment(true);
      const splitMonth = currentMonth.split("-");
      const year = splitMonth[0];
      const month = splitMonth[1];
      const exportExcel = document.getElementById("export-excel-payment");

      let data = { Items: [] };
      let lastItem = null;
      let datas = {};
      let count = 0;
      do {
        datas = await API.get("MoneyHubAdmin", "/loan/reportPayment", {
          queryStringParameters: {
            ...QUERY_ACTIVE,
            Limit: 1,
            year,
            month,
            ExclusiveStartKey: getLastItem(lastItem),
            // currentDate: `${month}${year}`,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = datas?.lastItem;
        count += datas?.count;
        data.Items = [...data.Items, ...datas.Items];
        setCountPayment(count);
      } while (lastItem);

      data.Items = data?.Items?.filter((item) => item);

      const totalInterestAmount = data?.Items?.reduce((prev, item) => {
        return prev + item?.INTEREST_AMOUNT;
      }, 0);

      const totalAmount = data?.Items?.reduce((prev, item) => {
        return prev + item?.AR_PAY_AMOUNT;
      }, 0);

      const totalPaidAmount = data?.Items?.reduce((prev, item) => {
        return prev + item?.paid_amount;
      }, 0);

      const totalAccrued_interest = data?.Items?.reduce((prev, item) => {
        return prev + item?.accrued_interest;
      }, 0);

      const lastRowTotal = {
        AR_PAY_AMOUNT: totalAmount,
        CONTRACT_PERIOD: "",
        INTEREST_AMOUNT: totalInterestAmount,
        REFERENCE: "",
        TAX_ID: "",
        accrued_interest: totalAccrued_interest,
        due_date: "",
        fullname: "",
        loan_id: "",
        paid_amount: totalPaidAmount,
        paid_date: "",
        paid_date_timestamp: "",
        requestTime: "",
        type: "",
      };

      setDataPayment([...data?.Items, lastRowTotal]);
      exportExcel.click();
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingExportPayment(false);
    }
  };

  const onClickExportInterestIncome = async () => {
    try {
      setLoadingExportInterestIncome(true);
      const splitMonth = currentMonth.split("-");
      const year = splitMonth[0];
      const month = splitMonth[1];
      const exportExcel = document.getElementById(
        "export-excel-interest-income"
      );

      let lastItem = null;
      let datas = {};
      let count = 0;
      let data = { body: { Items: [] } };

      do {
        datas = await API.get("MoneyHubAdmin", "/loan/reportInterestIncome", {
          queryStringParameters: {
            ...QUERY_ACTIVE,
            Limit: 1,
            year,
            currentMonth: `${month}`,
            ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = datas?.body?.lastItem;
        count += datas?.body?.count;
        data.body.Items = [...data.body.Items, ...datas.body.Items];
        setInterestInCome(count);
      } while (lastItem);

      const totalInterestIncome = data?.body.Items?.reduce((prev, item) => {
        return prev + item.fixed_accr_interest_receivable;
      }, 0);

      const lastRowTotal = {
        beginDate: "",
        endDate: "",
        fullname: "",
        loan_kbank_id: "",
        type: "",
        date: "",
        fixed_accr_interest_receivable: totalInterestIncome,
      };

      let items = data?.body.Items;

      items = items.reduce((prev, item) => {
        const findIndexFromRef = prev.findIndex(
          (prevItem) => prevItem.REFERENCE === item.REFERENCE
        );

        if (findIndexFromRef !== -1) {
          const prevForIndex = prev[findIndexFromRef];
          if (prevForIndex.REFERENCE === prevForIndex.REFERENCE) {
            prevForIndex.fixed_accr_interest_receivable +=
              item.fixed_accr_interest_receivable;
            prev[findIndexFromRef] = prevForIndex;
            return [...prev];
          }
        }

        return [...prev, item];
      }, []);

      setDataInterestIncome([...items, lastRowTotal]);
      exportExcel.click();
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingExportInterestIncome(false);
    }
  };

  const onClickExportExcelAging = async () => {
    try {
      setLoadingExportAging(true);
      const exportExcel = document.getElementById("export-excel-aging");
      const splitMonth = currentMonth.split("-");
      const year = splitMonth[0];
      const month = splitMonth[1];

      if (month === "11" && year === "2021") {
        const getReport = await Storage.get(`REPORT_2021-12-08.xlsx`);
        const link = document.createElement("a");
        link.href = getReport;
        link.setAttribute("download", `REPORT_2021-12-08.xlsx`);

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return;
      }

      if (month === "01" && year === "2022") {
        const getReport = await Storage.get(`REPORT_2022-01-31.xlsx`);
        const link = document.createElement("a");
        link.href = getReport;
        link.setAttribute("download", `REPORT_2022-01-31.xlsx`);

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return;
      }

      if (month === "02" && year === "2022") {
        const getReport = await Storage.get(`REPORT_2022-01-31.xlsx`);
        const link = document.createElement("a");
        link.href = getReport;
        link.setAttribute("download", `REPORT_2022-01-31.xlsx`);

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        return;
      }

      let dataActivePrinciple = { body: { Items: [] } };
      let lastItem = null;
      let datas = {};
      let count = 0;
      do {
        datas = await API.get("MoneyHubAdmin", "/loan/reportAging", {
          queryStringParameters: {
            ...QUERY_ACTIVE,
            paid_date: ctoday,
            ExclusiveStartKey: getLastItem(lastItem),
            year,
            month,
            keyCal: "actualPrinciple",
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = datas?.body?.lastItem;
        count += datas?.body?.count;
        dataActivePrinciple.body.Items = [
          ...dataActivePrinciple.body.Items,
          ...datas.body.Items,
        ];
        setCountAging(count);
      } while (lastItem);

      let dataActiveInterest = await API.get(
        "MoneyHubAdmin",
        "/loan/reportAging",
        {
          queryStringParameters: {
            ...QUERY_ACTIVE,
            paid_date: ctoday,
            year,
            month,
            keyCal: "actualInterest",
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      let dataFailPrinciple = await API.get(
        "MoneyHubAdmin",
        "/loan/reportAging",
        {
          queryStringParameters: {
            ...QUERY_FAIL,
            paid_date: ctoday,
            year,
            month,
            keyCal: "actualPrinciple",
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );
      let dataFailInterest = await API.get(
        "MoneyHubAdmin",
        "/loan/reportAging",
        {
          queryStringParameters: {
            ...QUERY_FAIL,
            paid_date: ctoday,
            year,
            month,
            keyCal: "actualInterest",
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      // console.log("dataActivePrinciple", dataActivePrinciple);

      const parseActivePrincipleItems = dataActivePrinciple.body.Items;
      const parseActiveInterestItems = dataActiveInterest.body.Items;

      const parseFailPrincipleItems = dataFailPrinciple.body.Items;
      const parseFailInterestItems = dataFailInterest.body.Items;

      let dataPrinciple = [
        ...parseActivePrincipleItems,
        ...parseFailPrincipleItems,
      ];
      let dataInterest = [
        ...parseActiveInterestItems,
        ...parseFailInterestItems,
      ];

      // dataPrinciple = dataPrinciple.filter((item) => {
      //   const dateTime = getCurrentLocalDateTime(
      //     new Date(item.requestTime)
      //   ).fullDate;
      //   if (
      //     (dateTime >= "2021-10-28" && dateTime <= "2021-10-31") ||
      //     (dateTime >= "2021-11-28" && dateTime <= "2021-11-30") ||
      //     (dateTime >= "2021-12-28" && dateTime <= "2021-12-31")
      //   ) {
      //     return item;
      //   }
      // });

      // console.log("1", dataPrinciple);

      setPrinciple([...dataPrinciple, calculatorLastTotal(dataPrinciple)]);
      setInterest([...dataInterest, calculatorLastTotal(dataInterest)]);
      exportExcel.click();
      setLoadingExportAging(false);
    } catch (error) {
      console.log("report aging error", error);
    } finally {
      setLoadingExportAging(false);
    }
  };

  const onClickExportExcelAllContract = async () => {
    try {
      setLoadingExportContract(true);
      const exportExcel = document.getElementById("export-excel-contract");

      let lastItem = null;
      let datas = {};
      let count = 0;
      let allData = { body: { Items: [] } };
      do {
        datas = await API.get("MoneyHubAdmin", "/loan/reportContract", {
          queryStringParameters: {
            ...QUERY_ALL,
            Limit: 100,
            min_created: min,
            max_created: max,
            SELECT_ALL: true,
            ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = datas?.body?.lastItem;
        count += datas?.body?.count;
        allData.body.Items = [...allData.body.Items, ...datas.body.Items];
        setCountContract(count);
      } while (lastItem);

      let parseData = allData.body.Items;

      let lastLoanTotal = {
        loan_id: "",
        type: "",
        lastname: "",
        name: "",
        gender: "",
        age: "",
        marritalStatus: "",
        education: "",
        careertype: "",
        income: "",
        burden: "",
        burdenSum: "",
        currentAddress: "",
        interestFuture: "",
        interestReceive: "",
        installments: "",
        loan_status: "",
        requestamount: "",
        capitalRemain: "",
        period: "",
        requestTime: "",
        endDate: "",
        interestMore: "",
        paid_date_latest: "",
      };

      lastLoanTotal.requestamount = parseData?.reduce((prev, loan) => {
        return prev + +loan.requestamount;
      }, 0);

      lastLoanTotal.capitalRemain = parseData?.reduce((prev, loan) => {
        return prev + +loan.capitalRemain;
      }, 0);

      // parseData = parseData.map((loan) => {
      //   return {
      //     ...loan,
      //     overdue_date: loan?.loan_status === "DONE" ? "" : loan?.overdue_date,
      //   };
      // });

      lastLoanTotal.interestFuture = parseData.interestFuture;
      lastLoanTotal.interestReceive = parseData.interestReceive;
      // lastLoanTotal.interestFuture = parseData?.reduce((prev, loan) => {
      //   return (
      //     prev +
      //     loan.installments.reduce((prev, installment) => {
      //       return prev + installment.planInterest;
      //     }, 0)
      //   );
      // }, 0);

      // lastLoanTotal.interestReceive = parseData?.reduce((prev, loan) => {
      //   return (
      //     prev +
      //     loan.installments.reduce((prev, installment) => {
      //       return prev + installment.receiveInterest;
      //     }, 0)
      //   );
      // }, 0);

      setAllContract([...parseData, lastLoanTotal]);
      exportExcel.click();
      setLoadingExportContract(false);
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const onClickExportExcelAllContract2 = async () => {
    try {
      setLoadingExportContract2(true);
      const exportExcel = document.getElementById("export-excel-contract2");

      let lastItem = null;
      let datas = {};
      let count = 0;
      let allData = { body: { Items: [] } };
      let dataInterest = { Items: [] };
      do {
        datas = await API.get("MoneyHubAdmin", "/loan/reportContract", {
          queryStringParameters: {
            ...QUERY_ALL,
            ref,
            dateInterest,
            min_created: min,
            max_created: max,
            SELECT_ALL: true,
            ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = datas?.body?.lastItem;
        count += datas?.body?.count;
        allData.body.Items = [...allData.body.Items, ...datas.body.Items];
        dataInterest = datas?.body?.dataInterest;
        setCountContract2(count);
      } while (lastItem);

      let parseData = allData.body.Items;

      for (let index = 0; index < parseData.length; index++) {
        let loan = parseData[index].original;

        let newInstallments = loan;

        if (
          loan?.loan_kbank_id !== "400009424" &&
          loan?.loan_status !== "DONE"
        ) {
          newInstallments = _.cloneDeep(
            await reinstallments(loan, dateInterest, dataInterest)
          );
        }

        let newLoan = await calcuratorInterestTwo(
          { ...loan, ...newInstallments },
          { dataInterest: dataInterest, where: { paid_date: dateInterest } }
        );

        let cloneLoan = _.cloneDeep(newLoan);

        let columnA = 0;
        let lastInstallmentIndex = -1;
        for (let index = 0; index < cloneLoan.installments.length; index++) {
          const installment = cloneLoan.installments[index];
          if (installment?.date <= dateInterest) {
            columnA += installment?.actualInterest;
            lastInstallmentIndex = index;
          }
        }

        // console.log("dateInterest", dateInterest);
        // console.log("columnA", columnA);
        // console.log("cloneLoan.installments", cloneLoan.installments);

        // if (lastInstallmentIndex > -1) {
        //   lastInstallmentIndex -= 1;
        // }

        let columnC = "0 วัน";
        for (const installment of cloneLoan.installments) {
          if (
            installment?.actualInterest + installment?.actualPrinciple > 0 &&
            installment.date <= dateInterest
          ) {
            const dateDiff = differenceInDays(
              new Date(dateInterest),
              new Date(installment.date)
            );
            columnC = `${dateDiff} วัน`;
            break;
          }
        }

        let filterInstallments = _.cloneDeep(newLoan?.installments)?.filter(
          (installment) => installment.date <= dateInterest
        );

        let threeInstallments = filterInstallments?.slice(-3);

        let columnB = threeInstallments?.reduce((prev, curr) => {
          return prev + curr?.actualInterest;
        }, 0);

        let sendDate = new Date(
          lastInstallmentIndex > -1
            ? cloneLoan.installments[lastInstallmentIndex].date
            : cloneLoan.requestTime
        );
        // sendDate.setDate(sendDate.getDate() + 1);

        let INTEREST_RATE_TYPE = dataInterest.Items.find(
          (item) => item.type === loan.type
        );
        let promo = +loan.promo || 0;
        let INTEREST_PROMO = +INTEREST_RATE_TYPE.value + promo;
        let INTEREST_RATE =
          +INTEREST_PROMO < 15 ? 15 / 100 : +INTEREST_PROMO / 100;
        const requestamount =
          lastInstallmentIndex > -1
            ? cloneLoan?.installments[lastInstallmentIndex]?.planCapitalRemain
            : cloneLoan.requestamount;
        const startLoanRequest = getCurrentLocalDateTime(sendDate);
        const itemSameAccruedInterest = {
          COMPANY_CODE: loan.COMPANY_CODE,
          REFERENCE: loan.REFERENCE,
          TAX_ID: loan.TAX_ID,
          CONTRACT_TYPE: loan.CONTRACT_TYPE,
          CURRENCY: loan.CURRENCY,
          loan_id: loan.loan_id,
          fullname: loan.fullname,
          period: `${+loan.period + 1}`,
          MESSAGE_TYPE: "",
          MESSAGE: "",
          checkZero: false,
        };
        const firstYear = pad(+startLoanRequest.year);
        const firstMonth = pad(+startLoanRequest.month);
        const firstDate = pad(months[startLoanRequest.monthIndex].days);
        const firstIntAccDate = `${firstYear}${firstMonth}${firstDate}`;
        const firstSendDate = `${firstYear}-${firstMonth}-${firstDate}`;
        const firstDiffDay =
          months[startLoanRequest.monthIndex].days -
          parseInt(startLoanRequest.date) +
          1;
        const firstReceivable =
          ((+requestamount * INTEREST_RATE) / 365) * firstDiffDay;
        const secondYear =
          +startLoanRequest.month + 1 === 13
            ? +startLoanRequest.year + 1
            : pad(+startLoanRequest.year);
        const secondMonth =
          +startLoanRequest.month + 1 === 13
            ? "01"
            : pad(+startLoanRequest.month + 1);
        const secondDate = pad(
          +startLoanRequest.date - 1 <= 0 ? 1 : +startLoanRequest.date - 1
        );
        let calSecDate = 0;
        if (+secondDate + 1 > months[secondMonth - 1].days) {
          calSecDate = secondDate - months[secondMonth - 1].days;
        }
        let secondDiffDay = +startLoanRequest.date - 1;
        if (calSecDate > 0) {
          secondYear =
            +secondMonth + 1 === 13 ? +secondYear + 1 : pad(+secondYear);
          secondMonth = +secondMonth + 1 === 13 ? "01" : pad(+secondMonth + 1);
          secondDate = pad(calSecDate);
          secondDiffDay = +startLoanRequest.date - 1;
        }
        let secondIntAccDate = `${secondYear}${secondMonth}${secondDate}`;
        let secondSendDate = `${secondYear}-${secondMonth}-${pad(
          +secondDate + 1
        )}`;
        const secondReceivable =
          ((+requestamount * INTEREST_RATE) / 365) * secondDiffDay <= 0
            ? 0
            : ((+requestamount * INTEREST_RATE) / 365) * secondDiffDay;
        const secondNote = `ดอกเบี้ยค้างรับ ${months[
          secondMonth - 1
        ].month.slice(0, 3)}-${secondYear}`;
        const itemSecondAccruedInterest = {
          data: {
            ...itemSameAccruedInterest,
            ACCR_INTEREST_RECEIVABLE: Math.floor(secondReceivable),
            fixed_accr_interest_receivable: Math.floor(secondReceivable),
            INT_ACCRUE_DOC_DATE: secondIntAccDate,
            INT_ACCRUE_POST_DATE: secondIntAccDate,
            TRANSACTION_NOTE: secondNote,
            sendDate: secondSendDate,
            days: secondDiffDay,
            nextSend: 0,
            sendMonth: +secondMonth,
            createdAt: getCurrentLocalDateTime().isoDateTime,
            timestamp: getCurrentLocalDateTime().timestamp,
          },
          config: {
            diffDay: secondDiffDay <= 0 ? 1 : secondDiffDay,
            month: secondMonth,
            date: secondDate,
            year: secondYear,
            fullDate: `${secondYear}-${secondMonth}-${secondDate}`,
          },
          options: {
            isFirst: false,
          },
        };
        const firstNote = `ดอกเบี้ยค้างรับ ${months[firstMonth - 1].month.slice(
          0,
          3
        )}-${firstYear}`;
        const two_digits = secondReceivable % 1;
        const itemFirstAccruedInterest = {
          data: {
            ...itemSameAccruedInterest,
            ACCR_INTEREST_RECEIVABLE: Math.ceil(firstReceivable + two_digits),
            fixed_accr_interest_receivable: Math.ceil(
              firstReceivable + two_digits
            ),
            INT_ACCRUE_DOC_DATE: firstIntAccDate,
            INT_ACCRUE_POST_DATE: firstIntAccDate,
            TRANSACTION_NOTE: firstNote,
            sendDate: firstSendDate,
            days: firstDiffDay,
            nextSend: 0,
            sendMonth: +firstMonth,
            createdAt: getCurrentLocalDateTime().isoDateTime,
            timestamp: getCurrentLocalDateTime().timestamp,
          },
          config: {
            diffDay: firstDiffDay,
            month: firstMonth,
            date: firstDate,
            year: firstYear,
            fullDate: `${firstYear}-${firstMonth}-${firstDate}`,
          },
          options: {
            isFirst: true,
          },
        };

        console.log("itemFirstAccruedInterest", itemFirstAccruedInterest);
        console.log("itemSecondAccruedInterest", itemSecondAccruedInterest);

        // console.log("lastInstallmentIndex", lastInstallmentIndex);

        if (lastInstallmentIndex > -1) {
          const diffDate = differenceInDays(
            new Date(dateInterest),
            new Date(cloneLoan.installments[lastInstallmentIndex].date)
          );

          if (diffDate > 0) {
            parseData[index].interestAcc =
              itemFirstAccruedInterest.data.ACCR_INTEREST_RECEIVABLE;
          }

          // console.log("installments", cloneLoan.installments);
          // console.log("itemFirstAccruedInterest", itemFirstAccruedInterest);
          // console.log("itemSecondAccruedInterest", itemSecondAccruedInterest);
        }

        let dataInterestFormat = getCurrentLocalDateTime(
          new Date(dateInterest)
        );

        if (
          dateInterest !==
          `${dataInterestFormat.year}-${pad(dataInterestFormat.month)}-${pad(
            months[dataInterestFormat.monthIndex].days
          )}`
        ) {
          parseData[index].interestAcc = 0;
        }

        if (
          itemSecondAccruedInterest?.data?.INT_ACCRUE_DOC_DATE ===
          `${dataInterestFormat.year}${pad(dataInterestFormat.month)}${pad(
            months[dataInterestFormat.monthIndex].days
          )}`
          // dateInterest ===
          // `${dataInterestFormat.year}-${pad(dataInterestFormat.month)}-${pad(
          //   months[dataInterestFormat.monthIndex].days
          // )}`
        ) {
          parseData[index].interestAcc =
            itemFirstAccruedInterest.data.ACCR_INTEREST_RECEIVABLE;
        }

        if (
          newLoan?.loan_kbank_id === "400009424" &&
          dateInterest === "20213-05-31"
        ) {
          parseData[index].interestAcc = 13;
        }

        let totalColumnA = columnA + parseData[index].interestAcc;
        let totalColumnB = columnB + parseData[index].interestAcc;

        console.log("totalColumnA", totalColumnA);
        console.log("columnA", columnA);
        console.log("c", parseData[index].interestAcc);
        console.log("columnC", columnC);
        console.log("newLoan", newLoan);

        if (newLoan?.loan_status === "DONE") {
          totalColumnA = 0;
          totalColumnB = 0;
          columnC = "0 วัน";
          newLoan.overdue_date = "";
          newLoan.interestMore = 0;
          newLoan.interestFuture = 0;
          // newLoan.interestReceive = 0
        }

        parseData[index] = {
          ...parseData[index],
          ...newLoan,
          columnA: newLoan?.loan_status === "DONE" ? 0 : totalColumnA,
          columnB: newLoan?.loan_status === "DONE" ? 0 : totalColumnB,
          columnC,
        };
      }

      let lastLoanTotal = {
        loan_id: "",
        type: "",
        lastname: "",
        name: "",
        gender: "",
        age: "",
        marritalStatus: "",
        education: "",
        careertype: "",
        income: "",
        burden: "",
        burdenSum: "",
        currentAddress: "",
        interestFuture: "",
        interestReceive: "",
        installments: "",
        loan_status: "",
        requestamount: "",
        capitalRemain: "",
        period: "",
        requestTime: "",
        endDate: "",
        interestMore: "",
        paid_date_latest: "",
        columnA: "",
        columnB: "",
        columnC: "",
        installments: [],
      };

      lastLoanTotal.requestamount = parseData?.reduce((prev, loan) => {
        return prev + +loan.requestamount;
      }, 0);

      lastLoanTotal.capitalRemain = parseData?.reduce((prev, loan) => {
        return prev + +loan.capitalRemain;
      }, 0);

      // lastLoanTotal.columnA = parseData.reduce((prev, loan) => {
      //   return prev + loan.columnA;
      // });

      // lastLoanTotal.columnB = parseData.reduce((prev, loan) => {
      //   return prev + loan.columnB;
      // });

      lastLoanTotal.interestFuture = parseData.interestFuture;
      lastLoanTotal.interestReceive = parseData.interestReceive;
      // lastLoanTotal.interestFuture = parseData?.reduce((prev, loan) => {
      //   return (
      //     prev +
      //     loan.installments.reduce((prev, installment) => {
      //       return prev + installment.planInterest;
      //     }, 0)
      //   );
      // }, 0);

      // lastLoanTotal.interestReceive = parseData?.reduce((prev, loan) => {
      //   return (
      //     prev +
      //     loan.installments.reduce((prev, installment) => {
      //       return prev + installment.receiveInterest;
      //     }, 0)
      //   );
      // }, 0);

      setAllContract2([...parseData, lastLoanTotal]);
      exportExcel.click();
      setLoadingExportContract2(false);
    } catch (error) {
      console.log("ERROR", error);
    }
  };

  const onClickExportAnalyzeScoring = async () => {
    try {
      setLoadingExportAnalyze(true);
      const exportExcel = document.getElementById("export-excel-analyze");
      let lateData = await API.get("MoneyHubAdmin", "/loan", {
        queryStringParameters: {
          ...QUERY_LATE,
          min_created: min,
          max_created: max,
          SELECT_ALL: true,
          // ProjectionExpression: ",installments, requestTime, interestMore",
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });

      const parseData = lateData.body.Items;

      let lastLoanTotal = {
        loan_id: "",
        type: "",
        lastname: "",
        name: "",
        gender: "",
        age: "",
        adminName: "",
        marritalStatus: "",
        education: "",
        careertype: "",
        income: "",
        burden: "",
        burdenSum: "",
        currentAddress: "",
        job_score: "",
        financial_score: "",
        status_score: "",
        installments: "",
        loan_status: "",
        requestamount: "",
        capitalRemain: "",
        period: "",
        requestTime: "",
        endDate: "",
        interestMore: "",
      };

      lastLoanTotal.requestamount = parseData?.reduce((prev, loan) => {
        return prev + +loan.requestamount;
      }, 0);

      lastLoanTotal.capitalRemain = parseData?.reduce((prev, loan) => {
        return prev + +loan.capitalRemain;
      }, 0);
      lastLoanTotal.financial_score =
        parseData?.reduce((prev, loan) => {
          return prev + +loan.financial_score;
        }, 0) / parseData.length;
      lastLoanTotal.status_score =
        parseData?.reduce((prev, loan) => {
          return prev + +loan.status_score;
        }, 0) / parseData.length;
      lastLoanTotal.job_score =
        parseData?.reduce((prev, loan) => {
          return prev + +loan.job_score;
        }, 0) / parseData.length;

      setLateData([...parseData, lastLoanTotal]);
      exportExcel.click();
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingExportAnalyze(false);
    }
  };

  const onClickExportForm = async () => {
    try {
      setLoadingExportForm(true);
      const exportExcel = document.getElementById("export-excel-form");
      let formData = await API.get("MoneyHubAdmin", "/loan/reportForm", {
        queryStringParameters: {
          ...QUERY_DEFAULT,
          min_created: min,
          max_created: max,
          SELECT_ALL: true,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });

      let parseData = formData.body.Items;

      console.log("parseData", parseData);

      parseData = parseData.filter((item) => {
        const minDateMinus = new Date(min);
        minDateMinus.setMonth(minDateMinus.getMonth() - 1);

        if (
          ["ACTIVE", "PENDING", "LATE"].includes(item?.loan_status) ||
          (item?.loan_status === "DONE" &&
            item?.requestTimeFullDate <=
              getCurrentLocalDateTime(minDateMinus).fullDate)
        ) {
          return item;
        }
      });

      setDataForm([...parseData]);
      exportExcel.click();
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingExportForm(false);
    }
  };

  const onClickExportAcc = async () => {
    try {
      setLoadingExportAccrued(true);
      const exportExcel = document.getElementById(
        "export-excel-accruedInterest"
      );
      const splitMonth = currentMonth.split("-");
      let year = splitMonth[0];
      let month = splitMonth[1];

      let lastItem = null;
      let datas = {};
      let count = 0;
      let formData = { body: { Items: [] } };

      do {
        datas = await API.get("MoneyHubAdmin", "/loan/reportAccruedInterest", {
          queryStringParameters: {
            year,
            month: `${pad(month)}`,
            ExclusiveStartKey: `${getLastItem(lastItem)}`,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = datas?.body?.lastItem;
        count += datas?.body?.count;
        formData.body.Items = [...formData.body.Items, ...datas.body.Items];
        setCountAcc(count);
      } while (lastItem);

      const parseData = formData.body?.Items || [];

      let tempKeyObject = {};
      parseData.forEach((item) => {
        tempKeyObject = {
          ...tempKeyObject,
          [item.loan_kbank_id]: tempKeyObject[item.loan_kbank_id]
            ? _.orderBy(
                [...tempKeyObject[item.loan_kbank_id], item],
                ["timestamp"],
                ["desc"]
              )
            : [item],
        };
      });

      const objectKeyToList = Object.keys(tempKeyObject);

      let newData = [];
      objectKeyToList.forEach((key) => {
        newData = [...newData, ...tempKeyObject[key]];
      });

      month++;
      if (month > 12) {
        month = 1;
      }

      newData = newData.filter((item) => {
        const requestTime = new Date(item.current_dueDate);
        if (requestTime.getMonth() + 1 === month) {
          return { ...item };
        }
      });

      setDataAcc([...newData]);
      exportExcel.click();
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingExportAccrued(false);
    }
  };

  const calculatorLastTotal = (data = []) => {
    const days = {
      notDue: 0,
      30: 0,
      "31_90": 0,
      "91_180": 0,
      "181_365": 0,
      365: 0,
    };
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      const keys = Object.keys(element);
      for (const key of keys) {
        if (typeof days[key] === "number") {
          days[key] += element[key];
        }
      }
    }
    days.total =
      days.notDue +
      days[30] +
      days["31_90"] +
      days["91_180"] +
      days["181_365"] +
      days[365];
    return { customer: "", ...days };
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    for (let i = 0; i < data.length; i++) {
      var filled =
        i == data.length - 1
          ? { patternType: "solid", fgColor: { rgb: "FEFF54" } }
          : { fgColor: { rgb: "FFFFFF" } };
      var filled_col_0 =
        i == data.length - 1
          ? { fgColor: { rgb: "FFFFFF" } }
          : { patternType: "solid", fgColor: { rgb: "FDFFA7" } };
      result.push([
        {
          value: `${data[i].reference || ""}`,
          style: { font: { sz: 14 }, alignment: "right", fill: filled_col_0 },
        },
        {
          value: data[i]?.name || "",
          style: { font: { sz: 14 }, alignment: "right" },
        },
        {
          value: data[i].loan_status || "",
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i].notDue,
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i][30],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]["31_90"],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]["91_180"],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i]["181_365"],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: data[i][365],
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        {
          value: +data[i].total,
          style: {
            font: { sz: 14 },
            numFmt: "0,0.00",
            border: borders,
            alignment: "right",
            fill: filled,
          },
        },
        // {
        //   value: data[i].monthCreated || "-",
        //   style: {
        //     font: { sz: 14 },
        //     // numFmt: "0,0.00",
        //     border: borders,
        //     alignment: "right",
        //     fill: filled,
        //   },
        // },
      ]);
    }
    return result;
  };

  const getDays = (days) => {
    if (days < 0) return `-`;
    return `${days} วัน`;
  };

  const createDataWithStyleContract = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14, name: "Cordia New" },
      border: borders,
      alignment: { vertical: "center", horizontal: "center" },
    };

    for (let i = 0; i < data.length; i++) {
      const currentAddress = _.toString(data[i].currentAddress).replace(
        " ",
        ","
      );
      const splitCurrentAddress = currentAddress?.split(",");

      const addressOri = _.toString(data[i].address).replace(" ", ",");
      const splitAddressOri = addressOri?.split(",");

      let address = {
        desc:
          `${data[i].officialAddressCode} ${data[i].officialAddressDesc}` ||
          "-",
        distirct: "-",
        subDistirct: "-",
        province: "-",
        postal_code: "-",
      };

      let currentAddressObj = {
        desc: `${data[i]?.addressCode} ${data[i]?.addressDesc}` || "-",
        distirct: "-",
        subDistirct: "-",
        province: "-",
        postal_code: "-",
      };

      if (splitAddressOri.length > 1) {
        const currentSubDistirct = `${splitAddressOri[0]}`;
        const currentDistirct = `${splitAddressOri[1]}`;
        const currentProvince = `${splitAddressOri[2]}`;
        const currentPostalCode = `${splitAddressOri[3]}`;
        if (currentSubDistirct) {
          currentAddressObj.subDistirct = currentSubDistirct;
        }
        if (currentDistirct) {
          currentAddressObj.distirct = currentDistirct;
        }
        if (currentProvince) {
          currentAddressObj.province = currentProvince;
        }
        if (currentPostalCode) {
          currentAddressObj.postal_code = currentPostalCode;
        }
      }

      if (splitCurrentAddress.length > 1) {
        const currentSubDistirct = `${splitCurrentAddress[0]}`;
        const currentDistirct = `${splitCurrentAddress[1]}`;
        const currentProvince = `${splitCurrentAddress[2]}`;
        const currentPostalCode = `${splitCurrentAddress[3]}`;
        if (currentSubDistirct) {
          address.subDistirct = currentSubDistirct;
        }
        if (currentDistirct) {
          address.distirct = currentDistirct;
        }
        if (currentProvince) {
          address.province = currentProvince;
        }
        if (currentPostalCode) {
          address.postal_code = currentPostalCode;
        }
      }
      //  else {
      //   if (splitAddressOri.length > 2) {
      //     const currentSubDistirct = `${splitAddressOri[0]}`;
      //     const currentDistirct = `${splitAddressOri[1]}`;
      //     const currentProvince = `${splitAddressOri[2]}`;
      //     const currentPostalCode = `${splitAddressOri[3]}`;
      //     if (currentSubDistirct) {
      //       address.subDistirct = currentSubDistirct;
      //     }
      //     if (currentDistirct) {
      //       address.distirct = currentDistirct;
      //     }
      //     if (currentProvince) {
      //       address.province = currentProvince;
      //     }
      //     if (currentPostalCode) {
      //       address.postal_code = currentPostalCode;
      //     }
      //   }
      // }

      if (i === data.length - 1) {
        delete style.border;
      }

      const historyPhone = data[i].historyPhone;
      let listHistoryPhone = [];
      if (historyPhone) {
        const splitHistoryPhone = historyPhone.split(" ");
        for (const itemSplitHistoryPhone of splitHistoryPhone) {
          listHistoryPhone.push({ value: itemSplitHistoryPhone, style });
        }
      }

      result.push([
        {
          value: i === data.length - 1 ? "" : i + 1,
          style,
        },
        {
          value: data[i]?.loan_kbank_id || "",
          style,
        },
        {
          value: data[i]?.citizenid || "",
          style,
        },
        {
          value: data[i]?.type || "",
          style,
        },
        {
          value: data[i]?.name + " " + data[i]?.lastname,
          style,
        },
        {
          value: data[i]?.gender || "",
          style,
        },
        {
          value: data[i]?.age || "",
          style,
        },
        {
          value: data[i]?.marritalStatus || "",
          style,
        },
        {
          value: data[i]?.education || "",
          style,
        },
        {
          value: data[i]?.careertype || "",
          style,
        },
        {
          value: data[i]?.income || "-",
          style,
        },
        {
          value:
            i === data.length - 1
              ? ""
              : `${+Math.ceil(
                  +data[i]?.income - +data[i]?.burden - +data[i]?.burdenSum
                )}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${address?.desc}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${address?.subDistirct}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${address?.distirct}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${address?.province}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${address?.postal_code}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${currentAddressObj?.desc}`,
          style,
        },
        {
          value:
            i === data.length - 1 ? "" : `${currentAddressObj?.subDistirct}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${currentAddressObj?.distirct}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${currentAddressObj?.province}`,
          style,
        },
        {
          value:
            i === data.length - 1 ? "" : `${currentAddressObj?.postal_code}`,
          style,
        },
        {
          value: i === data.length - 1 ? "Total" : `${data[i]?.loan_status}`,
          style,
        },
        {
          value: `${data[i]?.requestamount}`,
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
            },
          },
        },
        {
          value: `${
            data[i]?.refinanace_amount > 0 ? "0" : data[i]?.capitalRemain
          }`,
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
            },
          },
        },
        {
          value: data[i]?.interestFuture || "0",
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
            },
          },
        },
        {
          value: data[i]?.interestReceive || "0",
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
              color: { fgColor: { rgb: "17fbff" } },
            },
          },
        },
        {
          value: data[i]?.period,
          style,
        },
        {
          value:
            i === data.length - 1
              ? ""
              : format(new Date(data[i]?.requestTime), "dd/MM/yyyy"),
          style,
        },
        {
          value:
            i === data.length - 1
              ? ""
              : format(new Date(data[i]?.endDate), "dd/MM/yyyy"),
          style,
        },
        {
          value: data[i]?.interestMore || "0",
          style,
        },
        {
          value: data[i]?.completedAt
            ? format(new Date(data[i].completedAt), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i]?.completedBy || "-",
          style,
        },
        {
          value: data[i]?.approvedAt
            ? format(new Date(data[i].approvedAt), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i]?.approvedBy || "-",
          style,
        },
        {
          value: data[i]?.overdue_date
            ? `${getDays(
                differenceInDays(new Date(), new Date(data[i]?.overdue_date))
              )}`
            : "-",
          style,
        },
        {
          value: data[i]?.paid_date_latest
            ? format(new Date(data[i]?.paid_date_latest), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i]?.phone_number || "-",
          style,
        },
        ...listHistoryPhone,
        // {
        //   value: data[i]?.historyPhone || "-",
        //   style,
        // },
      ]);
    }
    return result;
  };

  const createDataWithStyleContract2 = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14, name: "Cordia New" },
      border: borders,
      alignment: { vertical: "center", horizontal: "center" },
    };

    for (let i = 0; i < data.length; i++) {
      const currentAddress = _.toString(data[i].currentAddress).replace(
        " ",
        ","
      );
      const splitCurrentAddress = currentAddress?.split(",");

      const addressOri = _.toString(data[i].address).replace(" ", ",");
      const splitAddressOri = addressOri?.split(",");

      let address = {
        desc:
          `${data[i].officialAddressCode} ${data[i].officialAddressDesc}` ||
          "-",
        distirct: "-",
        subDistirct: "-",
        province: "-",
        postal_code: "-",
      };

      let currentAddressObj = {
        desc: `${data[i]?.addressCode} ${data[i]?.addressDesc}` || "-",
        distirct: "-",
        subDistirct: "-",
        province: "-",
        postal_code: "-",
      };

      if (splitAddressOri.length > 1) {
        const currentSubDistirct = `${splitAddressOri[0]}`;
        const currentDistirct = `${splitAddressOri[1]}`;
        const currentProvince = `${splitAddressOri[2]}`;
        const currentPostalCode = `${splitAddressOri[3]}`;
        if (currentSubDistirct) {
          currentAddressObj.subDistirct = currentSubDistirct;
        }
        if (currentDistirct) {
          currentAddressObj.distirct = currentDistirct;
        }
        if (currentProvince) {
          currentAddressObj.province = currentProvince;
        }
        if (currentPostalCode) {
          currentAddressObj.postal_code = currentPostalCode;
        }
      }

      if (splitCurrentAddress.length > 1) {
        const currentSubDistirct = `${splitCurrentAddress[0]}`;
        const currentDistirct = `${splitCurrentAddress[1]}`;
        const currentProvince = `${splitCurrentAddress[2]}`;
        const currentPostalCode = `${splitCurrentAddress[3]}`;
        if (currentSubDistirct) {
          address.subDistirct = currentSubDistirct;
        }
        if (currentDistirct) {
          address.distirct = currentDistirct;
        }
        if (currentProvince) {
          address.province = currentProvince;
        }
        if (currentPostalCode) {
          address.postal_code = currentPostalCode;
        }
      }
      //  else {
      //   if (splitAddressOri.length > 2) {
      //     const currentSubDistirct = `${splitAddressOri[0]}`;
      //     const currentDistirct = `${splitAddressOri[1]}`;
      //     const currentProvince = `${splitAddressOri[2]}`;
      //     const currentPostalCode = `${splitAddressOri[3]}`;
      //     if (currentSubDistirct) {
      //       address.subDistirct = currentSubDistirct;
      //     }
      //     if (currentDistirct) {
      //       address.distirct = currentDistirct;
      //     }
      //     if (currentProvince) {
      //       address.province = currentProvince;
      //     }
      //     if (currentPostalCode) {
      //       address.postal_code = currentPostalCode;
      //     }
      //   }
      // }

      if (i === data.length - 1) {
        delete style.border;
      }

      const historyPhone = data[i].historyPhone;
      let listHistoryPhone = [];
      if (historyPhone) {
        const splitHistoryPhone = historyPhone.split(" ");
        for (const itemSplitHistoryPhone of splitHistoryPhone) {
          listHistoryPhone.push({ value: itemSplitHistoryPhone, style });
        }
      }

      result.push([
        {
          value: i === data.length - 1 ? "" : i + 1,
          style,
        },
        {
          value: data[i]?.loan_kbank_id || "",
          style,
        },
        {
          value: data[i]?.citizenid || "",
          style,
        },
        {
          value: data[i]?.type || "",
          style,
        },
        {
          value: data[i]?.name + " " + data[i]?.lastname,
          style,
        },
        {
          value: data[i]?.gender || "",
          style,
        },
        {
          value: data[i]?.age || "",
          style,
        },
        {
          value: data[i]?.marritalStatus || "",
          style,
        },
        {
          value: data[i]?.education || "",
          style,
        },
        {
          value: data[i]?.careertype || "",
          style,
        },
        {
          value: data[i]?.income || "-",
          style,
        },
        {
          value:
            i === data.length - 1
              ? ""
              : `${+Math.ceil(
                  +data[i]?.income - +data[i]?.burden - +data[i]?.burdenSum
                )}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${address?.desc}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${address?.subDistirct}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${address?.distirct}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${address?.province}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${address?.postal_code}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${currentAddressObj?.desc}`,
          style,
        },
        {
          value:
            i === data.length - 1 ? "" : `${currentAddressObj?.subDistirct}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${currentAddressObj?.distirct}`,
          style,
        },
        {
          value: i === data.length - 1 ? "" : `${currentAddressObj?.province}`,
          style,
        },
        {
          value:
            i === data.length - 1 ? "" : `${currentAddressObj?.postal_code}`,
          style,
        },
        {
          value: i === data.length - 1 ? "Total" : `${data[i]?.loan_status}`,
          style,
        },
        {
          value: `${data[i]?.requestamount}`,
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
            },
          },
        },
        {
          value: `${
            data[i]?.refinanace_amount > 0 ? "0" : data[i]?.capitalRemain
          }`,
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
            },
          },
        },
        {
          value: data[i]?.interestFuture || "0",
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
            },
          },
        },
        {
          value: data[i]?.interestReceive || "0",
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
              color: { fgColor: { rgb: "17fbff" } },
            },
          },
        },
        {
          value: data[i]?.period,
          style,
        },
        {
          value:
            i === data.length - 1
              ? ""
              : format(new Date(data[i]?.requestTime), "dd/MM/yyyy"),
          style,
        },
        {
          value:
            i === data.length - 1
              ? ""
              : format(new Date(data[i]?.endDate), "dd/MM/yyyy"),
          style,
        },
        {
          value: data[i]?.columnA || "0",
          style,
        },
        {
          value: data[i]?.columnB || "0",
          style,
        },
        {
          value: data[i]?.columnC || "0",
          style,
        },
        {
          value: data[i]?.interestMore || "0",
          style,
        },
        {
          value: data[i]?.completedAt
            ? format(new Date(data[i].completedAt), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i]?.completedBy || "-",
          style,
        },
        {
          value: data[i]?.approvedAt
            ? format(new Date(data[i].approvedAt), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i]?.approvedBy || "-",
          style,
        },
        {
          value: data[i]?.overdue_date
            ? `${getDays(
                differenceInDays(new Date(), new Date(data[i]?.overdue_date))
              )}`
            : "-",
          style,
        },
        {
          value: data[i]?.paid_date_latest
            ? format(new Date(data[i]?.paid_date_latest), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i]?.phone_number || "-",
          style,
        },
        ...listHistoryPhone,
        // {
        //   value: data[i]?.historyPhone || "-",
        //   style,
        // },
      ]);
    }
    return result;
  };

  const createDataWithStyleAnalyze = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14, name: "Cordia New" },
      border: borders,
      alignment: { vertical: "center", horizontal: "center" },
    };

    for (let i = 0; i < data.length; i++) {
      let currentInstallment = data[i].installments[0];

      // console.log("DATA", data[i]);

      const today = getCurrentLocalDateTime();

      const installments = data[i].installments;

      for (let index = 0; index < installments.length; index++) {
        const installment = installments[index];

        const prevIndex = index === 0 ? 0 : index - 1;

        const prevInstallment = installments[prevIndex];

        if (
          installment.date > prevInstallment.date &&
          installment.date <= today.fullDate &&
          !installment.disabledPeriod
        ) {
          currentInstallment = installment;
          break;
        }
      }

      result.push([
        {
          value: i === data.length - 1 ? "" : i + 1,
          style,
        },
        {
          value: data[i].loan_kbank_id || "-",
          style,
        },
        {
          value: data[i].type,
          style,
        },
        {
          value: data[i].name + " " + data[i].lastname,
          style,
        },
        {
          value: data[i].adminName || "-",
          style,
        },
        {
          value: i === data.length - 1 ? "Total" : "LATE",
          style,
        },
        {
          value: data[i].requestamount,
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
            },
          },
        },
        {
          value: data[i].capitalRemain,
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
            },
          },
        },
        {
          value: data[i].period,
          style,
        },
        {
          value:
            i === data.length - 1
              ? ""
              : format(new Date(data[i].requestTime), "dd/MM/yyyy"),
          style,
        },
        {
          value:
            i === data.length - 1
              ? ""
              : format(new Date(data[i].endDate), "dd/MM/yyyy"),
          style,
        },
        {
          value:
            i === data.length - 1
              ? ""
              : differenceInDays(new Date(), new Date(data[i].overdue_date)),
          style,
        },
        {
          value: data[i].interestMore || "-",
          style,
        },
        {
          value: data[i].status_score || "-",
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
            },
          },
        },
        {
          value: data[i].financial_score || "-",
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
            },
          },
        },
        {
          value: data[i].job_score || "-",
          style: {
            ...style,
            font: {
              ...style.font,
              underline: i === data.length - 1,
              bold: i === data.length - 1,
            },
          },
        },
        {
          value: data[i].gender,
          style,
        },
        {
          value: data[i].age || "-",
          style,
        },
        {
          value: data[i].marritalStatus || "-",
          style,
        },
        {
          value: data[i].education || "-",
          style,
        },
        {
          value: data[i].careertype || "-",
          style,
        },
        {
          value: data[i].income || "-",
          style,
        },
        {
          value:
            i === data.length - 1
              ? ""
              : `${+data[i].income - +data[i].burden - +data[i].burdenSum}`,
          style,
        },
        {
          value:
            i === data.length - 1
              ? ""
              : currentInstallment.planInterest +
                currentInstallment.planPrinciple,
          style,
        },
      ]);
    }
    return result;
  };

  const createDataWithStyleForm = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14, name: "Cordia New" },
      alignment: { vertical: "center", horizontal: "center" },
      border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      if (i === data.length - 1) {
        delete style.border;
      }
      result.push([
        {
          value: i + 1,
          style,
        },
        {
          value: data[i].name || "-",
          style,
        },
        {
          value: data[i].lastname || "-",
          style,
        },
        {
          value: data[i].citizenid || "-",
          style,
        },
        {
          value:
            data[i].addressCode +
              " " +
              data[i].addressDesc +
              " " +
              data[i].address || "-",
          style,
        },
        {
          value: data[i].bankNo || "-",
          style,
        },
        {
          value: data[i].buroDate
            ? format(new Date(data[i].buroDate), "dd-MM-yyyy")
            : "-", //วันที่นำส่งข้อมูลให้เครดิตบูโร
          style,
        },
        {
          value: data[i]?.ems_first_buro ? data[i]?.ems_first_buro : "-", // วันที่ส่งหนังสือแจ้งให้ลูกค้าทางไปรษณีย์
          style,
        },
        {
          value: data[i]?.ems_first_buro || "", //เลขเอกสารอ้างอิง
          style,
        },
        {
          value: "",
          style,
        },
      ]);
    }
    return result;
  };

  const createDataWithStyleAccruedInterest = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14, name: "Cordia New" },
      alignment: { vertical: "center", horizontal: "center" },
      border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      if (i === data.length - 1) {
        delete style.border;
      }
      result.push([
        {
          value: data[i]?.loan_kbank_id || "-",
          style,
        },
        {
          value: data[i]?.fullname || "-",
          style,
        },
        {
          value: data[i].paid_interest || "-",
          style,
        },
        {
          value: data[i]?.period || "-",
          style,
        },
        {
          value: data[i]?.type || "-",
          style,
        },
        {
          value: data[i]?.current_dueDate
            ? format(new Date(data[i].current_dueDate), "dd-MM-yyyy")
            : "",
          style,
        },
        {
          value: data[i]?.paid_date
            ? format(new Date(data[i].paid_date), "dd-MM-yyyy")
            : "",
          style,
        },
        {
          value: data[i]?.requestTime
            ? format(new Date(data[i].requestTime), "dd-MM-yyyy")
            : "",
          style,
        },
      ]);
    }
    return result;
  };

  const createDataWithStyleAccruedInterestCelestial = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14, name: "Cordia New" },
      alignment: { vertical: "center", horizontal: "center" },
      border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      if (i === data.length - 1) {
        delete style.border;
      }

      result.push([
        {
          value: data[i]?.REFERENCE || "-",
          style,
        },
        {
          value: `${data[i]?.fullname}` || "-",
          style,
        },
        {
          value: data[i]?.TAX_ID || "-",
          style,
        },
        {
          value: data[i]?.ACCR_INTEREST_RECEIVABLE || "-",
          style,
        },
        {
          value: data[i]?.fixed_accr_interest_receivable || "-",
          style,
        },
        {
          value: data[i]?.CONTRACT_TYPE || "-",
          style,
        },
        {
          value: data[i]?.INT_ACCRUE_POST_DATE || "-",
          style,
        },
        {
          value: data[i]?.INT_ACCRUE_DOC_DATE || "-",
          style,
        },
        {
          value: data[i]?.COMPANY_CODE || "-",
          style,
        },
        {
          value: data[i]?.TRANSACTION_NOTE || "-",
          style,
        },
        {
          value: data[i]?.checkZero ? "0" : data[i]?.MESSAGE || "",
          style,
        },
      ]);
    }
    return result;
  };

  const createDataWithStyleARClearCelestial = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14, name: "Cordia New" },
      alignment: { vertical: "center", horizontal: "center" },
      border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      if (i === data.length - 1) {
        delete style.border;
      }

      result.push([
        {
          value: data[i].REFERENCE || "-",
          style,
        },
        {
          value: data[i].TAX_ID || "-",
          style,
        },
        {
          value: data[i].fullname || "-",
          style,
        },
        {
          value: data[i].AR_PAY_AMOUNT || "-",
          style,
        },
        {
          value: data[i].INTEREST_AMOUNT || "-",
          style,
        },
        {
          value: data[i].IN_PAYMENT_TYPE || "-",
          style,
        },
        {
          value: data[i].CURRENCY || "-",
          style,
        },
        {
          value: data[i].CONTRACT_TYPE || "-",
          style,
        },
        {
          value: data[i].CONTRACT_PERIOD || "-",
          style,
        },
        {
          value: data[i].AR_CLEAR_DOC_DATE || "-",
          style,
        },
        {
          value: data[i].AR_CLEAR_POST_DATE || "-",
          style,
        },
        {
          value: data[i].CURRENCY || "-",
          style,
        },
        {
          value: data[i].MESSAGE || "-",
          style,
        },
        {
          value: data[i]?.timestamp
            ? format(new Date(data[i].timestamp), "dd-MM-yyyy HH:mm")
            : "-",
          style,
        },
      ]);
    }
    return result;
  };

  const createDataWithStylePayment = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14, name: "Cordia New" },
      alignment: { vertical: "center", horizontal: "center" },
      border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      if (i === data.length - 1) {
        delete style.border;
      }
      result.push([
        {
          value: i + 1 === data.length ? "" : i + 1,
          style,
        },
        {
          value: data[i].requestTime
            ? format(new Date(data[i].requestTime), "dd-MM-yyyy")
            : "",
          style,
        },
        {
          value: data[i].due_date
            ? format(new Date(data[i].due_date), "dd-MM-yyyy")
            : "",
          style,
        },
        {
          value: data[i].paid_date_timestamp
            ? `${format(new Date(data[i].paid_date_timestamp), "dd-MM-yyyy")}`
            : "",
          style,
        },
        {
          value: `${data[i].fullname}` || "",
          style,
        },
        {
          value: `${data[i].REFERENCE}` || "",
          style,
        },
        {
          value: `${data[i].type}` || "",
          style,
        },
        {
          value: `${numeral(data[i].paid_amount).format("0,0.00")}` || "",
          style,
        },
        {
          value: `${numeral(data[i].AR_PAY_AMOUNT).format("0,0.00")}` || "",
          style,
        },
        {
          value: `${numeral(data[i].INTEREST_AMOUNT).format("0,0.00")}` || "",
          style,
        },
        {
          value: `${numeral(data[i].accrued_interest).format("0,0.00")}` || "",
          style,
        },
      ]);
    }
    return result;
  };

  const createDataWithStyleInterestIncome = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    let style = {
      font: { sz: 14, name: "Cordia New" },
      alignment: { vertical: "center", horizontal: "center" },
      border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      var filled = { fgColor: { rgb: "FFFFFF" } };
      style = {
        ...style,
        fill: filled,
      };
      result.push([
        {
          style,
          value: i === data.length - 1 ? "" : i + 1,
        },
        // {
        //   style,
        //   value: data[i].requestTime
        //     ? format(new Date(data[i].requestTime), "dd-MM-yyyy")
        //     : "",
        // },
        // {
        //   style,
        //   value: data[i].endDate
        //     ? format(new Date(data[i].endDate), "dd-MM-yyyy")
        //     : "",
        // },
        // {
        //   style,
        //   value: data[i].date
        //     ? format(new Date(data[i].date), "dd-MM-yyyy")
        //     : "",
        // },
        {
          style,
          value: data[i]?.fullname || "",
        },
        {
          style,
          value: data[i]?.REFERENCE || "",
        },
        // {
        //   style,
        //   value: data[i]?.type || "",
        // },
        {
          style,
          value:
            numeral(data[i]?.fixed_accr_interest_receivable).format(
              "0,00.00"
            ) || "",
        },
      ]);
    }
    return result;
  };

  const createDataWithStyleInterfaceCreate = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    let style = {
      font: { sz: 14, name: "Cordia New" },
      alignment: { vertical: "center", horizontal: "center" },
      border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      var filled = { fgColor: { rgb: "FFFFFF" } };
      style = {
        ...style,
        fill: filled,
      };
      result.push([
        {
          style,
          value: i + 1,
        },
        {
          style,
          value: data[i]?.REFERENCE,
        },
        {
          style,
          value: data[i]?.TITLE,
        },
        {
          style,
          value: data[i]?.NAME,
        },
        {
          style,
          value: data[i]?.MOBILE_PHONE,
        },
        {
          style,
          value: data[i]?.TAX_ID,
        },
        {
          style,
          value: data[i]?.CONTRACT_TYPE,
        },
        {
          style,
          value: data[i]?.LOAN_AMOUNT,
        },
        {
          style,
          value: data[i]?.CURRENCY,
        },
        {
          style,
          value: data[i]?.PAYMENT_DOC_DATE,
        },
        {
          style,
          value: data[i]?.PAYMENT_POST_DATE,
        },
        {
          style,
          value: data[i]?.VALUE_DATE,
        },
        {
          style,
          value: data[i]?.REGISTRATION_TYPE,
        },
        {
          style,
          value: data[i]?.EMAIL,
        },
        {
          style,
          value: data[i]?.ADDRESS,
        },
        {
          style,
          value: data[i]?.REGION,
        },
        {
          style,
          value: data[i]?.POSTAL_CODE,
        },
        {
          style,
          value: data[i]?.BANK_KEY,
        },
        {
          style,
          value: data[i]?.BANK_ACCOUNT,
        },
        {
          style,
          value: data[i]?.BANK_TYPE,
        },
        {
          style,
          value: data[i]?.ACCT_HOLDER,
        },
        {
          style,
          value: data[i]?.CUSTOMER_PAY_TERM,
        },
        {
          style,
          value: data[i]?.VENDOR_PAY_TERM,
        },
        {
          style,
          value: data[i]?.BRANCH_CODE,
        },
        {
          style,
          value: data[i]?.COMPANY_CODE,
        },
      ]);
    }
    return result;
  };

  const createDataWithStyleInterfaceCreateCelestial = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    let style = {
      font: { sz: 14, name: "Cordia New" },
      alignment: { vertical: "center", horizontal: "center" },
      border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      var filled = { fgColor: { rgb: "FFFFFF" } };
      style = {
        ...style,
        fill: filled,
      };
      result.push([
        {
          style,
          value: i + 1,
        },
        {
          style,
          value: data[i]?.REFERENCE,
        },
        {
          style,
          value: data[i]?.TITLE,
        },
        {
          style,
          value: data[i]?.NAME,
        },
        {
          style,
          value: data[i]?.MOBILE_PHONE,
        },
        {
          style,
          value: data[i]?.TAX_ID,
        },
        {
          style,
          value: data[i]?.CONTRACT_TYPE,
        },
        {
          style,
          value: data[i]?.LOAN_AMOUNT,
        },
        {
          style,
          value: data[i]?.CURRENCY,
        },
        {
          style,
          value: data[i]?.PAYMENT_DOC_DATE,
        },
        {
          style,
          value: data[i]?.PAYMENT_POST_DATE,
        },
        {
          style,
          value: data[i]?.VALUE_DATE,
        },
        {
          style,
          value: data[i]?.REGISTRATION_TYPE,
        },
        {
          style,
          value: data[i]?.EMAIL,
        },
        {
          style,
          value: data[i]?.ADDRESS,
        },
        {
          style,
          value: data[i]?.REGION,
        },
        {
          style,
          value: data[i]?.POSTAL_CODE,
        },
        {
          style,
          value: data[i]?.BANK_KEY,
        },
        {
          style,
          value: data[i]?.BANK_ACCOUNT,
        },
        {
          style,
          value: data[i]?.BANK_TYPE,
        },
        {
          style,
          value: data[i]?.ACCT_HOLDER,
        },
        {
          style,
          value: data[i]?.CUSTOMER_PAY_TERM,
        },
        {
          style,
          value: data[i]?.VENDOR_PAY_TERM,
        },
        {
          style,
          value: data[i]?.BRANCH_CODE,
        },
        {
          style,
          value: data[i]?.COMPANY_CODE,
        },
        {
          style,
          value: data[i]?.MESSAGE,
        },
        {
          style,
          value: data[i]?.MESSAGE_TYPE,
        },
        {
          style,
          value: data[i]?.sendSapAt,
        },
      ]);
    }
    return result;
  };

  const styleColumnContract = {
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    borders: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
    fill: { fgColor: { rgb: "dbdbdb" } },
  };

  const styleColumnInterestIncome = {
    fill: { patternType: "solid", fgColor: { rgb: "FFFF00" } },
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    borders: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
  };

  const style = {
    font: { sz: 14, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    fill: { patternType: "solid", fgColor: { rgb: "FFFF00" } },
    // border: borderColumn,
  };

  const multiDataSetAnalyze = [
    {
      columns: [
        {
          title: "No",
          width: { wch: 10 },
          style: styleColumnContract,
        },
        {
          title: "Contract No",
          width: { wch: 36 },
          style: styleColumnContract,
        },
        {
          title: "Contract Type",
          width: { wch: 12 },
          style: styleColumnContract,
        },
        {
          title: "Customer Name",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ชื่อผู้พิจารณา",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "Status",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "ยอดสินเชื่อทั้งหมด",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "ยอดสินเชื่อคงเหลือ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "จำนวนงวด",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "วันที่เริ่มต้นสัญญา",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "วันที่สิ้นสุดสัญญา",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "Overdue Day",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "ดอกเบี้ยสะสม จากการค้างชำระ",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "ด้านสถานภาพ",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ด้านการเงิน",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ด้านการทำงาน",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "เพศ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "อายุ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "สถานะ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "ระดับการศึกษา",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "อาชีพ",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "รายรับ / เดือน",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "รายรับคงเหลือ / เดือน",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ค่างวดต่อเดือน",
          width: { wch: 24 },
          style: styleColumnContract,
        },
      ],
      data: createDataWithStyleAnalyze(lateData),
    },
  ];

  const getColumnHistoryPhone = () => {
    let maxHistoryPhone = 0;
    let lastMaxIndex = 0;
    for (let i = 0; i < allContract.length; i++) {
      const item = allContract[i];
      if (item.historyPhone) {
        let splitHistoryPhone = String(item.historyPhone).split(" ");
        splitHistoryPhone = splitHistoryPhone.filter(
          (historyPhone) => historyPhone
        );
        if (splitHistoryPhone.length > maxHistoryPhone) {
          maxHistoryPhone = splitHistoryPhone.length;
          lastMaxIndex = i;
        }
      }
    }

    let columnHistoryPhone = [];
    for (let index = 0; index < maxHistoryPhone; index++) {
      columnHistoryPhone.push({
        title: `History Phone ${index + 1}`,
        width: { wch: 24 },
        style: styleColumnContract,
      });
    }

    return {
      columnHistoryPhone,
      maxHistoryPhone,
      lastMaxIndex,
    };
  };

  const multiDataSetContract = [
    {
      columns: [
        {
          title: "No",
          width: { wch: 10 },
          style: styleColumnContract,
        },
        {
          title: "Contract No",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Citizen Id",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Contract Type",
          width: { wch: 12 },
          style: styleColumnContract,
        },
        {
          title: "Customer Name",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "เพศ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "อายุ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "สถานะ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "ระดับการศึกษา",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "อาชีพ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "รายรับ / เดือน",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "รายรับคงเหลือ / เดือน",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ปัจจุบัน (บ้านเลขที่ / ถนน / ซอย)",
          width: { wch: 32 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ปัจจุบัน (ตำบล)",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ปัจจุบัน (อำเภอ)",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ปัจจุบัน (จังหวัด)",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ปัจจุบัน (รหัสไปรษณีย์)",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (บ้านเลขที่ / ถนน / ซอย)",
          width: { wch: 40 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (ตำบล)",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (อำเภอ)",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (จังหวัด)",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (รหัสไปรษณีย์)",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Status",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "ยอดสินเชื่อทั้งหมด",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ยอดสินเชื่อคงเหลือ",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ดอกเบี้ยประมาณการ",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ดอกเบี้ยที่ได้รับแล้ว",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "จำนวนงวด",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "วันที่เริ่มต้นสัญญา",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "วันที่สิ้นสุดสัญญา",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ดอกเบี้ยสะสม จากการค้างชำระ",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Complete Date",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Complete By",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Approve Date",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Approved By",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Overdue date",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Last Payment Date",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Phone",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        ...getColumnHistoryPhone().columnHistoryPhone,
        // {
        //   title: "History Phone",
        //   width: { wch: 24 },
        //   style: styleColumnContract,
        // },
      ],
      data: createDataWithStyleContract(allContract),
    },
  ];

  const multiDataSetContract2 = [
    {
      columns: [
        {
          title: "No",
          width: { wch: 10 },
          style: styleColumnContract,
        },
        {
          title: "Contract No",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Citizen Id",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Contract Type",
          width: { wch: 12 },
          style: styleColumnContract,
        },
        {
          title: "Customer Name",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "เพศ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "อายุ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "สถานะ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "ระดับการศึกษา",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "อาชีพ",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "รายรับ / เดือน",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "รายรับคงเหลือ / เดือน",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ปัจจุบัน (บ้านเลขที่ / ถนน / ซอย)",
          width: { wch: 32 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ปัจจุบัน (ตำบล)",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ปัจจุบัน (อำเภอ)",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ปัจจุบัน (จังหวัด)",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ปัจจุบัน (รหัสไปรษณีย์)",
          width: { wch: 18 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (บ้านเลขที่ / ถนน / ซอย)",
          width: { wch: 40 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (ตำบล)",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (อำเภอ)",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (จังหวัด)",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ที่อยู่ตามทะเบียนบ้าน (รหัสไปรษณีย์)",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Status",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "ยอดสินเชื่อทั้งหมด",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ยอดสินเชื่อคงเหลือ",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ดอกเบี้ยประมาณการ",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "ดอกเบี้ยที่ได้รับแล้ว",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "จำนวนงวด",
          width: { wch: 14 },
          style: styleColumnContract,
        },
        {
          title: "วันที่เริ่มต้นสัญญา",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "วันที่สิ้นสุดสัญญา",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: `ดอกเบี้ยสะสม จากการค้างชำระ ณ วันที่ ${dateInterest}`,
          width: { wch: 32 },
          style: styleColumnContract,
        },
        {
          title: `ดอกเบี้ยสะสม จากการค้างชำระ 3 เดือนย้อนหลัง ณ วันที่ ${dateInterest}`,
          width: { wch: 32 },
          style: styleColumnContract,
        },
        {
          title: `Overdue Date ${dateInterest}`,
          width: { wch: 32 },
          style: styleColumnContract,
        },
        {
          title: "ดอกเบี้ยสะสม จากการค้างชำระ",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Complete Date",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Complete By",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Approve Date",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Approved By",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Overdue date",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Last Payment Date",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        {
          title: "Phone",
          width: { wch: 24 },
          style: styleColumnContract,
        },
        ...getColumnHistoryPhone().columnHistoryPhone,
        // {
        //   title: "History Phone",
        //   width: { wch: 24 },
        //   style: styleColumnContract,
        // },
      ],
      data: createDataWithStyleContract2(allContract2),
    },
  ];

  const multiDataSet = [
    {
      columns: [
        {
          title: "Reference",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        }, //pixels width
        {
          title: "Name",
          width: { wch: 30 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        }, //pixels width
        {
          title: "Status",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "4287f5" } } },
        }, //pixels width
        {
          title: "Not Due",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        }, //char width
        {
          title: "0 - 30",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "31 - 90",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "91 - 180",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "181 - 365",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "> 365",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "Total",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
      ],
      data: createDataWithStyle(dataPrinciple),
    },
  ];

  const multiDataSetInterest = [
    {
      columns: [
        {
          title: "Reference",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        }, //pixels width
        {
          title: "Name",
          width: { wch: 30 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "8B7243" } } },
        }, //pixels width
        {
          title: "Status",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "4287f5" } } },
        }, //pixels width
        {
          title: "Not Due",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        }, //char width
        {
          title: "0 - 30",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "31 - 90",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "91 - 180",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "181 - 365",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "> 365",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
        {
          title: "Total",
          width: { wch: 12 },
          style: { fill: { patternType: "solid", fgColor: { rgb: "FDFFA7" } } },
        },
      ],
      data: createDataWithStyle(dataInterest),
    },
  ];

  const multiDataSetForm = [
    {
      columns: [
        {
          title: "ลำดับที่",
          width: { wch: 16 },
          style,
        },
        {
          title: "ชื่อ",
          width: { wch: 34 },
          style,
        },
        {
          title: "นามสกุล",
          width: { wch: 34 },
          style,
        },
        {
          title: "เลขที่บัตรประชาชน",
          width: { wch: 24 },
          style,
        },
        {
          title: "ที่อยู่",
          width: { wch: 74 },
          style,
        },
        {
          title: "เลขที่บัญชี",
          width: { wch: 16 },
          style,
        },
        {
          title: "วันที่นำส่งข้อมูลให้เครดิตบูโร",
          width: { wch: 34 },
          style,
        },
        {
          title: "วันที่ส่งหนังสือแจ้งให้ลูกค้าทางไปรษณีย์",
          width: { wch: 34 },
          style,
        },
        {
          title: "เลขเอกสารอ้างอิง",
          width: { wch: 34 },
          style,
        },
        {
          title: "หมายเหตุ",
          width: { wch: 24 },
          style,
        },
      ],
      data: createDataWithStyleForm(dataForm),
    },
  ];

  const multiDataSetAccrued = [
    {
      columns: [
        {
          title: "เลขสัญญา",
          width: { wch: 34 },
          style,
        },
        {
          title: "ชื่อ นามสกุล",
          width: { wch: 34 },
          style,
        },
        {
          title: "ดอกเบี้ยรับล่วงหน้า",
          width: { wch: 34 },
          style,
        },
        {
          title: "งวด",
          width: { wch: 34 },
          style,
        },
        {
          title: "ประเภท",
          width: { wch: 34 },
          style,
        },
        {
          title: "วันที่กำหนดชำระ",
          width: { wch: 16 },
          style,
        },
        {
          title: "วันที่ชำระ",
          width: { wch: 16 },
          style,
        },
        {
          title: "วันที่ปล่อยกู้",
          width: { wch: 16 },
          style,
        },
      ],
      data: createDataWithStyleAccruedInterest(dataAcc),
    },
  ];

  const multiDataSetAccruedCelestial = [
    {
      columns: [
        {
          title: "REFERENCE",
          width: { wch: 34 },
          style,
        },
        {
          title: "NAME",
          width: { wch: 34 },
          style,
        },
        {
          title: "TAX_ID",
          width: { wch: 34 },
          style,
        },
        {
          title: "ACCR_INTEREST_RECEIVABLE",
          width: { wch: 34 },
          style,
        },
        {
          title: "fixed_accr_interest_receivable",
          width: { wch: 34 },
          style,
        },
        {
          title: "CONTRACT_TYPE",
          width: { wch: 34 },
          style,
        },
        {
          title: "INT_ACCRUE_POST_DATE",
          width: { wch: 34 },
          style,
        },
        {
          title: "INT_ACCRUE_DOC_DATE",
          width: { wch: 34 },
          style,
        },
        {
          title: "COMPANY_CODE",
          width: { wch: 34 },
          style,
        },
        {
          title: "TRANSACTION_NOTE",
          width: { wch: 34 },
          style,
        },
        {
          title: "MESSAGE",
          width: { wch: 34 },
          style,
        },
      ],
      data: createDataWithStyleAccruedInterestCelestial(dataAcc),
    },
  ];

  const multiDataSetArClearCelestial = [
    {
      columns: [
        {
          title: "REFERENCE",
          width: { wch: 34 },
          style,
        },
        {
          title: "TAX_ID",
          width: { wch: 34 },
          style,
        },
        {
          title: "NAME",
          width: { wch: 34 },
          style,
        },
        {
          title: "AR_PAY_AMOUNT",
          width: { wch: 34 },
          style,
        },
        {
          title: "INTEREST_AMOUNT",
          width: { wch: 34 },
          style,
        },
        {
          title: "IN_PAYMENT_TYPE",
          width: { wch: 34 },
          style,
        },
        {
          title: "CURRENCY",
          width: { wch: 34 },
          style,
        },
        {
          title: "CONTRACT_TYPE",
          width: { wch: 34 },
          style,
        },
        {
          title: "CONTRACT_PERIOD",
          width: { wch: 34 },
          style,
        },
        {
          title: "AR_CLEAR_DOC_DATE",
          width: { wch: 34 },
          style,
        },
        {
          title: "AR_CLEAR_POST_DATE",
          width: { wch: 34 },
          style,
        },
        {
          title: "CURRENCY",
          width: { wch: 34 },
          style,
        },
        {
          title: "MESSAGE",
          width: { wch: 56 },
          style,
        },
        {
          title: "PAID DATE",
          width: { wch: 56 },
          style,
        },
      ],
      data: createDataWithStyleARClearCelestial(dataPayment),
    },
  ];

  const multiDataSetPayment = [
    {
      columns: [
        {
          title: "ลำดับที่",
          width: { wch: 16 },
          style,
        },
        {
          title: "วันที่กู้",
          width: { wch: 34 },
          style,
        },
        {
          title: "ครบกำหนด",
          width: { wch: 34 },
          style,
        },
        {
          title: "รับชำระ",
          width: { wch: 24 },
          style,
        },
        {
          title: "ชื่อ",
          width: { wch: 34 },
          style,
        },
        {
          title: "เลขที่สัญญา",
          width: { wch: 34 },
          style,
        },
        {
          title: "ประเภทสินเชื่อ",
          width: { wch: 34 },
          style,
        },
        {
          title: "จำนวนเงิน",
          width: { wch: 34 },
          style,
        },
        {
          title: "เงินต้น",
          width: { wch: 34 },
          style,
        },
        {
          title: "ดอกเบี้ย",
          width: { wch: 34 },
          style,
        },
        {
          title: "ดอกเบี้ยค้างรับ",
          width: { wch: 34 },
          style,
        },
      ],
      data: createDataWithStylePayment(dataPayment),
    },
  ];

  const multiDataSetInterestIncome = [
    {
      columns: [
        {
          title: "ลำดับที่",
          width: { wch: 16 },
          style: styleColumnInterestIncome,
        },
        // {
        //   title: "วันที่เริ่มสัญญา",
        //   width: { wch: 34 },
        //   style: styleColumnInterestIncome,
        // },
        // {
        //   title: "วันที่สิ้นสุดสัญญา",
        //   width: { wch: 34 },
        //   style: styleColumnInterestIncome,
        // },
        // {
        //   title: "วันที่กำหนดชำระ",
        //   width: { wch: 34 },
        //   style: styleColumnInterestIncome,
        // },
        {
          title: "ชื่อ",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "เลขที่สัญญา",
          width: { wch: 24 },
          style: styleColumnInterestIncome,
        },
        // {
        //   title: "ประเภทสินเชื่อ",
        //   width: { wch: 34 },
        //   style: styleColumnInterestIncome,
        // },
        {
          title: "รายได้ดอกเบี้ย",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
      ],
      data: createDataWithStyleInterestIncome(dataInterestIncome),
    },
  ];

  const multiDataSetInterface = [
    {
      columns: [
        {
          title: "NO.",
          width: { wch: 16 },
          style: styleColumnInterestIncome,
        },
        {
          title: "REFERENCE",
          width: { wch: 24 },
          style: styleColumnInterestIncome,
        },
        {
          title: "TITLE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "NAME",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "MOBILE_PHONE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "TAX_ID",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "CONTRACT_TYPE",
          width: { wch: 24 },
          style: styleColumnInterestIncome,
        },
        {
          title: "LOAN_AMOUNT",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "CURRENCY",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "PAYMENT_DOC_DATE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "PAYMENT_POST_DATE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "VALUE_DATE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "REGISTRATION_TYPE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "EMAIL",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "ADDRESS",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "REGION",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "POSTAL_CODE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "BANK_KEY",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "BANK_ACCOUNT",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "BANK_TYPE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "ACCT_HOLDER",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "CUSTOMER_PAY_TERM",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "VENDOR_PAY_TERM",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "BRANCH_CODE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "COMPANY_CODE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
      ],
      data: createDataWithStyleInterfaceCreate(dataInterface),
    },
  ];

  const multiDataSetInterfaceCelestial = [
    {
      columns: [
        {
          title: "NO.",
          width: { wch: 16 },
          style: styleColumnInterestIncome,
        },
        {
          title: "REFERENCE",
          width: { wch: 24 },
          style: styleColumnInterestIncome,
        },
        {
          title: "TITLE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "NAME",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "MOBILE_PHONE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "TAX_ID",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "CONTRACT_TYPE",
          width: { wch: 24 },
          style: styleColumnInterestIncome,
        },
        {
          title: "LOAN_AMOUNT",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "CURRENCY",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "PAYMENT_DOC_DATE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "PAYMENT_POST_DATE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "VALUE_DATE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "REGISTRATION_TYPE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "EMAIL",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "ADDRESS",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "REGION",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "POSTAL_CODE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "BANK_KEY",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "BANK_ACCOUNT",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "BANK_TYPE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "ACCT_HOLDER",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "CUSTOMER_PAY_TERM",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "VENDOR_PAY_TERM",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "BRANCH_CODE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "COMPANY_CODE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "MESSAGE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "MESSAGE_TYPE",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
        {
          title: "วันที่ส่ง SAP",
          width: { wch: 34 },
          style: styleColumnInterestIncome,
        },
      ],
      data: createDataWithStyleInterfaceCreateCelestial(dataInterface),
    },
  ];

  const createDataWithStyleSES = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    let style = {
      font: { sz: 14, name: "Cordia New" },
      alignment: { vertical: "center", horizontal: "center" },
      border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      var filled = { fgColor: { rgb: "FFFFFF" } };
      style = {
        ...style,
        fill: filled,
      };
      result.push([
        {
          style,
          value: data[i]?.SESLoanKbankId || "",
        },
        {
          style,
          value: data[i]?.SESDestinationAddress || "",
        },
        {
          style,
          value: data[i]?.SESSubject || "",
        },
        {
          style,
          value: data[i]?.SnsPublishTime
            ? format(new Date(data[i]?.SnsPublishTime), "dd/MM/yyyy HH:mm")
            : "-",
        },
        {
          style,
          value: data[i]?.SnsReceiptTime
            ? format(new Date(data[i]?.SnsReceiptTime), "dd/MM/yyyy HH:mm")
            : "-",
        },
        {
          style,
          value: data[i]?.SESMessageType || "",
        },
        {
          style,
          value: data[i]?.SESbounceSummary
            ? JSON.parse(data[i]?.SESbounceSummary)[0]?.diagnosticCode
            : "-",
        },
        {
          style,
          value: data[i]?.SESbounceSubType || "-",
        },
      ]);
    }
    return result;
  };

  const createDataWithStyleLoanFeb = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    let style = {
      font: { sz: 14, name: "Cordia New" },
      alignment: { vertical: "center", horizontal: "center" },
      border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      var filled = { fgColor: { rgb: "FFFFFF" } };
      style = {
        ...style,
        fill: filled,
      };
      result.push([
        {
          style,
          value: data[i]?.loan_kbank_id || "",
        },
        {
          style,
          value: data[i]?.requestTimeFullDate
            ? format(new Date(data[i]?.requestTimeFullDate), "dd/MM/yyyy")
            : "-",
        },
        {
          style,
          value: `${data[i]?.currentActualInterest}`,
        },
        {
          style,
          value: `${data[i]?.newActualInterest}`,
        },
      ]);
    }
    return result;
  };

  const multiDataSetSES = [
    {
      columns: [
        {
          title: "JOB_NO",
          width: { wch: 16 },
          style: styleColumnInterestIncome,
        },
        {
          title: "EMAIL",
          width: { wch: 32 },
          style: styleColumnInterestIncome,
        },
        {
          title: "SUBJECT",
          width: { wch: 32 },
          style: styleColumnInterestIncome,
        },
        {
          title: "SEND_DATE",
          width: { wch: 32 },
          style: styleColumnInterestIncome,
        },
        {
          title: "RECEIPT_DATE",
          width: { wch: 32 },
          style: styleColumnInterestIncome,
        },
        {
          title: "STATUS",
          width: { wch: 16 },
          style: styleColumnInterestIncome,
        },
        {
          title: "SESBounceSummary",
          width: { wch: 96 },
          style: styleColumnInterestIncome,
        },
        {
          title: "SESbounceSubType",
          width: { wch: 20 },
          style: styleColumnInterestIncome,
        },
      ],
      data: createDataWithStyleSES(sess),
    },
  ];

  const multiDataSetFeb = [
    {
      columns: [
        {
          title: "เลขที่สัญญา",
          width: { wch: 16 },
          style: styleColumnInterestIncome,
        },
        {
          title: "วันที่เริ่มสัญญา",
          width: { wch: 32 },
          style: styleColumnInterestIncome,
        },
        {
          title: "ดอกเบี้ยปัจจุบัน",
          width: { wch: 32 },
          style: styleColumnInterestIncome,
        },
        {
          title: "ดอกเบี้ยใหม่",
          width: { wch: 32 },
          style: styleColumnInterestIncome,
        },
      ],
      data: createDataWithStyleLoanFeb(loanFeb),
    },
  ];

  const BoxChooseDate = () => {
    return (
      <div className="p-4 border border-gray-200 shadow-xl my-0">
        <div className="font-bold text-xl">Report Interface (By Date)</div>
        <div className="">
          <div>เลือกวันที่</div>
          <input
            type="date"
            value={selectToday}
            onChange={(e) => setSelectToday(e.target.value)}
            className="p-2 border border-gray-200 mt-2 w-full rounded-lg"
          />
          <button
            disabled={loadingExportInterfaceCreate}
            className={classNames(
              "p-4 w-full text-white mt-2 flex flex-row rounded-lg items-center",
              {
                "bg-green-500": !loadingExportInterfaceCreate,
                "bg-gray-400": loadingExportInterfaceCreate,
              }
            )}
            onClick={onClickExportInterfaceCreate}
          >
            {loadingExportInterfaceCreate && (
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx={12}
                  cy={12}
                  r={10}
                  stroke="currentColor"
                  strokeWidth={4}
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
            )}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
              />
            </svg>
            Interface Create
          </button>
        </div>
      </div>
    );
  };

  const BoxChooseMonth = () => {
    return (
      <div className="p-4 border border-gray-200 shadow-xl my-0">
        <div className="font-bold text-xl">Report Interface (By Month)</div>
        <div>เลือกเดือน</div>
        <input
          type="month"
          value={currentMonth}
          onChange={(e) => setCurrentMonth(e.target.value)}
          className="p-2 border border-gray-200 mt-2 w-full"
        />
        {/* <button
          disabled={loadingExportAging}
          className={classNames(
            "p-4  text-white mt-2 w-full flex flex-row rounded-lg items-center",
            {
              "bg-blue-500": !loadingExportAging,
              "bg-gray-400": loadingExportAging,
            }
          )}
          onClick={onClickExportExcelAging}
        >
          {loadingExportAging && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          {countAging > 0 && countAging} Download Aging Report
        </button> */}
        <button
          disabled={loadingExportPayment}
          className={classNames(
            "p-4  text-white mt-2 flex flex-row rounded-lg items-center w-full",
            {
              "bg-blue-500": !loadingExportPayment,
              "bg-gray-400": loadingExportPayment,
            }
          )}
          onClick={onClickExportPayment}
        >
          {loadingExportPayment && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          {countPayment > 0 && countPayment} Report Payment
        </button>
        <button
          disabled={loadingExportInterestIncome}
          className={classNames(
            "p-4 w-full text-white mt-2 flex flex-row rounded-lg items-center w-full",
            {
              "bg-green-500": !loadingExportInterestIncome,
              "bg-gray-400": loadingExportInterestIncome,
            }
          )}
          onClick={onClickExportInterestIncome}
        >
          {loadingExportInterestIncome && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          {countInterestInCome > 0 && countInterestInCome} Report Interest
          Income
        </button>
        <button
          disabled={loadingExportAccrued}
          className={classNames(
            "p-4  text-white mt-2 flex flex-row rounded-lg items-center w-full",
            {
              "bg-green-500": !loadingExportAccrued,
              "bg-gray-400": loadingExportAccrued,
            }
          )}
          onClick={onClickExportAcc}
        >
          {loadingExportAccrued && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
            />
          </svg>
          {countAcc > 0 && countAcc} Adjust Interest
        </button>
      </div>
    );
  };

  return (
    <ContainerContent>
      <div className="grid grid-cols-4 mx-0 h-screen -mt-4">
        <div className="p-4 border border-gray-200 shadow-xl flex flex-col">
          {/* <div>วันที่ปัจจุบันเพื่อเทส OverdueDate (เฉพาะ Aging)</div>
          <input
            type="date"
            className="p-2 border border-gray-200 mt-2"
            value={ctoday}
            onChange={(e) => setCToday(e.target.value)}
          /> */}
          <div className="font-bold text-xl">Report General</div>
          <div>วันที่ล่าสุดของข้อมูล (ถ้าไม่กำหนดวันที่จะใช้วันปัจจุบัน)</div>
          วันเริ่มต้น
          <input
            type="date"
            className="p-2 border border-gray-200 mt-2 rounded-lg"
            value={min}
            onChange={(e) => setMin(e.target.value)}
          />
          วันสิ้นสุด
          <input
            type="date"
            className="p-2 border border-gray-200 mt-2 rounded-lg"
            value={max}
            onChange={(e) => setMax(e.target.value)}
          />
          วันที่คิดดอกเบี้ย
          <input
            type="date"
            // disabled
            className="p-2 border border-gray-200 mt-2 rounded-lg mb-2"
            value={dateInterest}
            onChange={(e) => setDateInterest(e.target.value)}
          />
          REFERENCE (Contract 2 for test)
          <input
            type="text"
            // disabled
            className="p-2 border border-gray-200 mt-2 rounded-lg "
            value={ref}
            onChange={(e) => setRef(e.target.value)}
          />
          <button
            disabled={loadingExportAging}
            className={classNames(
              "p-4  text-white mt-2 flex flex-row rounded-lg items-center",
              {
                "bg-green-500": !loadingExportContract,
                "bg-gray-400": loadingExportContract,
              }
            )}
            onClick={onClickExportExcelAllContract}
          >
            {loadingExportContract && (
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx={12}
                  cy={12}
                  r={10}
                  stroke="currentColor"
                  strokeWidth={4}
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
            )}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
              />
            </svg>
            {countContract > 0 && countContract} Download All Contract Report
          </button>
          <button
            disabled={loadingExportAnalyze}
            className={classNames(
              "p-4  text-white mt-2 flex flex-row rounded-lg items-center",
              {
                "bg-red-500": !loadingExportAnalyze,
                "bg-gray-400": loadingExportAnalyze,
              }
            )}
            onClick={onClickExportAnalyzeScoring}
          >
            {loadingExportAnalyze && (
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx={12}
                  cy={12}
                  r={10}
                  stroke="currentColor"
                  strokeWidth={4}
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
            )}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"
              />
            </svg>
            Download Analyze Scoring
          </button>
          <button
            disabled={loadingExportForm}
            className={classNames(
              "p-4  text-white mt-2 flex flex-row rounded-lg items-center",
              {
                "bg-yellow-500": !loadingExportForm,
                "bg-gray-400": loadingExportForm,
              }
            )}
            onClick={onClickExportForm}
          >
            {loadingExportForm && (
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx={12}
                  cy={12}
                  r={10}
                  stroke="currentColor"
                  strokeWidth={4}
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
            )}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
              />
            </svg>
            Download Form
          </button>
          <ReportRelationship min={min} max={max} selectToday={selectToday} />
          <ReportARClearRemain min={min} max={max} selectToday={selectToday} />
          <ReportGood min={min} max={max} selectToday={selectToday} />
          <ReportBad min={min} max={max} selectToday={selectToday} />
          <button
            disabled={loadingExportAging}
            className={classNames(
              "p-4  text-white mt-2 flex flex-row rounded-lg items-center",
              {
                "bg-green-500": !loadingExportContract2,
                "bg-gray-400": loadingExportContract2,
              }
            )}
            onClick={onClickExportExcelAllContract2}
          >
            {loadingExportContract2 && (
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx={12}
                  cy={12}
                  r={10}
                  stroke="currentColor"
                  strokeWidth={4}
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
            )}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
              />
            </svg>
            {countContract2 > 0 && countContract2} Download All Contract Report
            2
          </button>
        </div>
        <BoxChooseMonth />
        <BoxChooseDate />
        <BoxChooseDateCelestialCode
          selectToday={selectToday}
          countAccrued={countAccrued}
          countAccruedError={countAccruedError}
          loadingAccruedError={loadingAccruedError}
          setSelectToday={setSelectToday}
          loadingOne={loadingOne}
          loadingTwo={loadingTwo}
          loadingThree={loadingThree}
          loadingExportArClearCelestial={loadingExportArClearCelestial}
          loadingExportInterfaceCreateCelestial={
            loadingExportInterfaceCreateCelestial
          }
          loadingExportAccruedCelestial={loadingExportAccruedCelestial}
          onClickExportInterfaceCreateCelestial={
            onClickExportInterfaceCreateCelestial
          }
          onClickExportAccruedInterestCelestial={
            onClickExportAccruedInterestCelestial
          }
          onClickExportAccruedInterestCelestialError={
            onClickExportAccruedInterestCelestialError
          }
          onClickExportARClearCelestial={onClickExportARClearCelestial}
          ses={sess}
          setSess={setSess}
          setLoanFeb={setLoanFeb}
        />
      </div>

      <ExcelFile
        filename={`REPORT_${format(new Date(), "yyyy-MM-dd")}`}
        element={<button id="export-excel-aging" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSet} name="Principle"></ExcelSheet>
        <ExcelSheet dataSet={multiDataSetInterest} name="Interest"></ExcelSheet>
      </ExcelFile>

      <ExcelFile
        filename={`ALL_CONTRACT_${format(new Date(), "yyyy-MM-dd")}`}
        element={<button id="export-excel-contract" hidden></button>}
      >
        <ExcelSheet
          dataSet={multiDataSetContract}
          name="All Contract"
        ></ExcelSheet>
      </ExcelFile>

      <ExcelFile
        filename={`ALL_CONTRACT_2_${format(new Date(), "yyyy-MM-dd")}`}
        element={<button id="export-excel-contract2" hidden></button>}
      >
        <ExcelSheet
          dataSet={multiDataSetContract2}
          name="All Contract 2"
        ></ExcelSheet>
      </ExcelFile>

      <ExcelFile
        filename={`ANALYZE_SCORING_${format(new Date(), "yyyy-MM-dd")}`}
        element={<button id="export-excel-analyze" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSetAnalyze} name="Form"></ExcelSheet>
      </ExcelFile>

      <ExcelFile
        filename={`FORM_${format(new Date(), "yyyy-MM-dd")}`}
        element={<button id="export-excel-form" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSetForm} name="Form"></ExcelSheet>
      </ExcelFile>

      <ExcelFile
        filename={`ADJUST_INTEREST_${format(new Date(), "yyyy-MM-dd")}`}
        element={<button id="export-excel-accruedInterest" hidden></button>}
      >
        <ExcelSheet
          dataSet={multiDataSetAccrued}
          name="Adjust Interest"
        ></ExcelSheet>
      </ExcelFile>

      <ExcelFile
        filename={`PAYMENT_${format(new Date(), "yyyy-MM-dd")}`}
        element={<button id="export-excel-payment" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSetPayment} name="Payment"></ExcelSheet>
      </ExcelFile>

      <ExcelFile
        filename={`INTEREST_INCOME_${format(new Date(), "yyyy-MM-dd")}`}
        element={<button id="export-excel-interest-income" hidden></button>}
      >
        <ExcelSheet
          dataSet={multiDataSetInterestIncome}
          name="InterestIncome"
        ></ExcelSheet>
      </ExcelFile>

      <ExcelFile
        filename={`INTERFACE_CREATE_${format(
          new Date(selectToday),
          "yyyy-MM-dd"
        )}`}
        element={<button id="export-excel-interface-create" hidden></button>}
      >
        <ExcelSheet
          dataSet={multiDataSetInterface}
          name="InterfaceCreate"
        ></ExcelSheet>
      </ExcelFile>

      <ExcelFile
        filename={`INTERFACE_CREATE_${format(
          new Date(selectToday),
          "yyyy-MM-dd"
        )}`}
        element={
          <button id="export-excel-interface-create-celestial" hidden></button>
        }
      >
        <ExcelSheet
          dataSet={multiDataSetInterfaceCelestial}
          name="InterfaceCreate"
        ></ExcelSheet>
      </ExcelFile>

      <ExcelFile
        filename={`ACCRUED_INTEREST_${format(new Date(), "yyyy-MM-dd")}`}
        element={
          <button id="export-excel-accruedInterest-celestial" hidden></button>
        }
      >
        <ExcelSheet
          dataSet={multiDataSetAccruedCelestial}
          name="Accrued Interest"
        ></ExcelSheet>
      </ExcelFile>

      <ExcelFile
        filename={`AR_CLEAR_${format(new Date(), "yyyy-MM-dd")}`}
        element={<button id="export-excel-arclear-celestial" hidden></button>}
      >
        <ExcelSheet
          dataSet={multiDataSetArClearCelestial}
          name="AR Clear"
        ></ExcelSheet>
      </ExcelFile>

      <ExcelFile
        filename={`REPORT_SES_${format(new Date(selectToday), "yyyy-MM-dd")}`}
        element={<button id="export-excel-ses" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSetSES} name="SES"></ExcelSheet>
      </ExcelFile>

      <ExcelFile
        filename={`REPORT_LOAN_FEB_${format(
          new Date(selectToday),
          "yyyy-MM-dd"
        )}`}
        element={<button id="export-excel-loan-feb" hidden></button>}
      >
        <ExcelSheet dataSet={multiDataSetFeb} name="LOAN_FEB"></ExcelSheet>
      </ExcelFile>
    </ContainerContent>
  );
}

export default ReportMain;
